<template>
  <!-- Entorno Grafico Front-End -->
  
<v-row>

<div class="split-container" style="display: flex; width: 100%; height: calc(100vh - 120px); overflow: hidden;">
  
  <!-- Panel izquierdo - Árbol de carpetas -->
  <div :style="{ width: leftWidth + 'px', minWidth: '200px', maxWidth: '80%', flexShrink: 0 }">
    <v-card class="mx-auto" style="height: 100%;">
      <v-sheet class="pa-4" color="#004d82">
        <v-text-field
          v-model="search"
          label="Buscar Carpeta"
          variant="solo"
          clearable flat hide-details
        ></v-text-field>
        <v-checkbox-btn
          v-model="caseSensitive"
          label="Búsqueda sensible a mayúsculas y minúsculas"
        ></v-checkbox-btn>
      </v-sheet>
      <v-list v-model:opened="openedGroups" style="overflow-y: auto; max-height: calc(100% - 120px);">
        <tree-node
          v-for="item in filteredItems"
          :key="item.tocId"
          :node="item"
          :selected-folder="selectedFolder"
          :template-id="selectedFolderTemplateId"
          :moving-folder="movingFolder"
          @load-subcarpetas="handleLoadSubcarpetas"
          @folder-selected="handleFolderSelected"
          @reload-subcarpetas="handleReloadSubcarpetas"
          @folder-move-requested="handleFolderMoveRequested"
          @cambiar-tab="handleCambiarTab"
          @folder-deleted="handleFolderDeleted"  
          @enfocar-tabla="enfocarTablaArchivos"
        />
      </v-list>
    </v-card>
  </div>

  <!-- ===== DIVISOR ARRASTRABLE ===== -->
  <div
    class="split-divider"
    @mousedown="startResize"
    title="Arrastrar para redimensionar"
  >
    <div class="split-divider-handle">
      <div class="split-divider-circle"></div>
    </div>
  </div>

  <!-- Panel derecho - Tabla de archivos -->
  <div style="flex: 1; min-width: 200px; overflow: hidden;">
    <v-card class="mx-auto" style="height: 100%; display: flex; flex-direction: column;">
      <div style="display: flex; align-items: center; padding: 12px 16px; min-height: 56px;">
        <v-icon class="ml-4 mr-2" style="color: #ce501b;">mdi-folder</v-icon>
        <span style="font-size: 1rem; font-weight: 500;">Carpeta: </span>
        <v-chip v-if="selectedFolder" class="ml-6 chip-destacado" color="primary" size="small" variant="tonal">
          {{ selectedFolder.name }}
        </v-chip>

        <!-- NUEVO -->
         <v-icon class="ml-4 mr-2" style="color: #ce501b;">mdi-file-document-multiple</v-icon>
        <span class="ml-4" style="font-size: 1rem; font-weight: 500;">Plantilla: </span>
        <v-chip v-if="selectedFolderTemplateName" class="ml-6 chip-destacado" color="primary" size="small" variant="tonal">
          {{ selectedFolderTemplateName }}
        </v-chip>
         
        <!-- ✅ NUEVO: Buscador de archivos -->
        <v-text-field
          v-model="buscarArchivo"
          placeholder="Buscar en la tabla..."
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          clearable
          hide-details
          class="ml-6"
          style="max-width: 280px;"
        ></v-text-field>

        <div style="flex: 1;"></div>
        <span style="font-size: 1rem; font-weight: 500;">Exportar en Excel</span>
        <v-btn
          v-if="filesInSelectedFolder.length > 0"
          icon
          size="small"
          variant="text"
          title="Exportar a Excel (todos los registros)"
          @click="exportarExcel"
          :loading="exportandoExcel"
        >
          <v-icon size="32" color="green-darken-2">mdi-microsoft-excel</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
    <div style="flex: 1; overflow-y: auto; min-height: 0;">
      <v-data-table
        :headers="fileHeaders"
        :items="archivosFiltrados"
        :loading="loadingFiles"
        item-key="tocId"
        class="elevation-1"
        no-data-text="Selecciona una carpeta para ver sus archivos"
      >
        <template v-slot:item="{ item }">
          <tr
            @contextmenu.prevent="abrirMenuArchivo($event, item)"
            @click="seleccionarArchivo(item)"
            @dblclick="visualizarArchivo(item)"
            :class="{ 'fila-seleccionada': archivoSeleccionado?.tocId === item.tocId }"
            class="fila-archivo"
            style="cursor: pointer;"
          >
            <td>
              <div class="d-flex align-center">
                <v-icon class="mr-2" size="small" :color="getFileIconColor(item.name)">
                  {{ getFileIcon(item.name) }}
                </v-icon>
                {{ item.name }}
              </div>
            </td>
            <td v-for="campo in estructuraDinamica" :key="'col-' + campo.column_name">
              {{ formatearValorDinamico(item['dyn_' + campo.column_name], campo.data_type) }}
            </td>
            <td>{{ formatearPesoMB(item.peso) }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    </v-card>
  </div>

</div>

</v-row>

  <!-- ============================================================== -->
  <!-- MENÚ CONTEXTUAL PARA ARCHIVOS (Click Derecho)                  -->
  <!-- ============================================================== -->
  <v-menu
    v-model="showMenuArchivo"
    :style="{ left: menuArchivoX + 'px', top: menuArchivoY + 'px' }"
    absolute
    offset-y
    :close-on-content-click="true"
  >
    <v-list density="compact" nav class="menu-contextual">
      <!-- Exportar -->
      
      <v-list-item v-if="puedeEscribir || puedeLeer" @click="confirmarExportar" :loading="exportandoArchivo" class="menu-item">
        <template v-slot:prepend>
          <v-icon color="esArchivoExportablePDF ? 'primary' : 'teal-darken-1'">
            {{ esArchivoExportablePDF ? 'mdi-export' : 'mdi-download' }}
          </v-icon>
        </template>
        <v-list-item-title>
        {{ esArchivoExportablePDF ? 'Exportar' : 'Descargar Archivo' }}
        </v-list-item-title>
      </v-list-item>
       
      <!-- Indexación -->
     <v-list-item v-if="puedeEscribir" @click="indexarArchivo" class="menu-item">
        <template v-slot:prepend>
          <v-icon color="orange-darken-2">mdi-text-box-search</v-icon>
        </template>
        <v-list-item-title>{{ textoMenuIndexacion }}</v-list-item-title>
      </v-list-item>

      <!-- Desindexar (solo si el archivo ya tiene indexación) -->
      <v-list-item v-if="puedeEscribir && esEdicionIndexacion" @click="desindexarArchivo" class="menu-item">
        <template v-slot:prepend>
          <v-icon color="warning">mdi-text-box-remove</v-icon>
        </template>
        <v-list-item-title>Desindexar</v-list-item-title>
      </v-list-item>

      <!-- Generar OCR -->
      <v-list-item v-if="puedeEscribir || puedeLeer" @click="generarOCR" class="menu-item">
        <template v-slot:prepend>
          <v-icon color="purple">mdi-text-recognition</v-icon>
        </template>
        <v-list-item-title>Generar OCR</v-list-item-title>
      </v-list-item>

      <v-divider class="my-1"></v-divider>

      <!-- Eliminar -->
      <v-list-item v-if="puedeEscribir" @click="eliminarArchivo" class="menu-item">
        <template v-slot:prepend>
          <v-icon color="error">mdi-delete</v-icon>
        </template>
        <v-list-item-title class="text-error">Eliminar</v-list-item-title>
      </v-list-item>

      <v-divider class="my-1"></v-divider>

      <!-- Versiones -->
      <v-list-item 
      v-if="esArchivoConVersiones"
      @click="verVersiones"
      class="menu-item"
      >
        <template v-slot:prepend>
          <v-icon color="blue-grey">mdi-history</v-icon>
        </template>
        <v-list-item-title>Versiones</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>


  <!-- ============================================================== -->
  <!-- DIALOG: INDEXACIÓN DE ARCHIVO                                  -->
  <!-- ============================================================== -->
 
<v-dialog v-model="dialogIndexarArchivo" max-width="1400px" persistent class="dialog-indexacion">
  <v-card style="height: 100%; display: flex; flex-direction: column; overflow: hidden;">
    
    <!-- Header -->
    <v-card-title class="text-h6 text-white d-flex align-center py-2 px-4" style="flex-shrink: 0; background-color: #004d82;">
      <v-icon class="mr-2">mdi-text-box-search</v-icon>
      Indexación de Archivo
      <v-spacer></v-spacer>
      <v-btn icon size="small" variant="text" @click="dialogIndexarArchivo = false; archivoNoVisualizable = false">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <!-- Contenido principal: 2 columnas -->
    <div style="display: flex; flex: 1; overflow: hidden; min-height: 0;">

      <!-- ===== PANEL IZQUIERDO: VISOR ===== -->
      <div style="flex: 7; display: flex; flex-direction: column; border-right: 1px solid #e0e0e0; min-height: 0;">

        <!-- Barra de herramientas -->
        <div class="d-flex align-center pa-1" style="border-bottom: 1px solid #e0e0e0; background: #f5f5f5; flex-shrink: 0;">
        
          <!-- Botón activar/desactivar modo anotación -->
          <v-btn
            :icon="false"
            v-if="AccesoAnotacion"
            size="x-small"
            :variant="modoAnotacion ? 'flat' : 'text'"
            :color="modoAnotacion ? 'orange' : undefined"
            title="Modo anotación"
            @click="modoAnotacion = !modoAnotacion"
          >
            <v-icon size="16" class="mr-1">mdi-marker</v-icon>
            <span style="font-size: 11px;">{{ modoAnotacion ? 'Anotando...' : 'Anotar' }}</span>
          </v-btn>

          <!-- Botón guardar anotaciones -->
          <v-btn
            v-if="anotaciones.length > 0"
            :icon="false"
            size="x-small"
            variant="text"
            color="success"
            title="Guardar anotaciones"
            @click="guardarAnotaciones"
          >
            <v-icon size="16" class="mr-1">mdi-content-save</v-icon>
            <span style="font-size: 11px;">Guardar Anotaciones ({{ anotaciones.length }})</span>
          </v-btn>

           <v-btn
              v-if="AccesoImprimir"
              :icon="false"
              size="x-small"
              variant="text"
              title="Imprimir"
              @click="imprimirPDF"
            >
              <v-icon size="16" class="mr-1">mdi-printer</v-icon>
              <span style="font-size: 11px;">Imprimir</span>
            </v-btn>

             <!-- NUEVO: Botón Enviar Correo -->
            <v-btn
              :icon="false"
              size="x-small"
              variant="text"
              title="Enviar por correo"
              @click="enviarCorreo"
            >
              <v-icon size="16" class="mr-1">mdi-email-outline</v-icon>
              <span style="font-size: 11px;">Enviar Correo</span>
            </v-btn>

        </div>

        <!-- Área del visor — ocupa TODO el espacio restante -->
        
      <div 
          style="flex: 1; background: #808080; overflow: hidden; min-height: 0; position: relative;"
          :style="{ cursor: modoAnotacion ? 'crosshair' : 'default' }"
          @click="agregarAnotacion"
          @wheel="handleZoomWheelArchivo"
        >
         
          <!-- Cargando -->
          <div v-if="cargandoPdfVisor" style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <v-progress-circular indeterminate color="white" size="40"></v-progress-circular>
              <p class="text-white mt-2 text-body-2">Cargando documento...</p>
            </div>
          </div>

         <!-- Error -->
          <div v-else-if="errorPdfVisor"
            style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
            <div class="text-center px-4">
              <v-icon size="56" color="white" class="mb-3">
                {{ errorPdfVisor.includes('ZIP') ? 'mdi-folder-zip-outline' : 'mdi-file-alert-outline' }}
              </v-icon>
              <p class="text-white text-body-1 font-weight-medium">
                {{ errorPdfVisor.split('\n')[0] }}
              </p>
              <p v-if="errorPdfVisor.includes('\n')" class="text-white text-caption mt-1" style="opacity: 0.8;">
                {{ errorPdfVisor.split('\n')[1] }}
              </p>
            </div>
          </div>

          <!-- Documento Word: descarga disponible, sin intentar renderizar -->
          <div v-else-if="archivoNoVisualizable"
            style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
            <div class="text-center px-4">
              <v-icon size="64" color="white">mdi-file-word-outline</v-icon>
              <p class="text-white text-body-1 font-weight-medium mt-3">Documento Word</p>
              <p class="text-white text-body-2 mt-2">Este formato no puede visualizarse directamente.</p>
              <v-btn class="mt-4" color="primary" @click.stop="descargarDocumentoWord">
                <v-icon start>mdi-download</v-icon>
                Descargar archivo
              </v-btn>
            </div>
          </div>

          <!-- Imagen -->
        <!-- Imagen con zoom + drag -->
          
              <div
                v-else-if="urlPdfVisor && esImagenVisor && !modoPaginasMultiples"
                style="position: absolute; inset: 0; display: flex; flex-direction: column; background: #808080;"
              >
                <!-- Barra de zoom (encima de la imagen — misma posición que multi-página) -->
                <div
                  style="display: flex; align-items: center; justify-content: center; gap: 8px;
                         padding: 4px 12px; background: #555; flex-shrink: 0;
                         border-bottom: 1px solid #666;"
                >
                  <button @click.stop="zoomOutArchivo"
                    :disabled="zoomArchivoLevel <= MIN_ZOOM_ARCHIVO"
                    style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                          border-radius:3px; cursor:pointer; font-size:16px;"
                    :style="{ opacity: zoomArchivoLevel <= MIN_ZOOM_ARCHIVO ? '0.3' : '0.9' }"
                    title="Alejar">−</button>

                  <span style="color:white; font-size:12px; min-width:50px; text-align:center;">
                    {{ Math.round(zoomArchivoLevel * 100) }}%
                  </span>

                  <button @click.stop="zoomInArchivo"
                    :disabled="zoomArchivoLevel >= MAX_ZOOM_ARCHIVO"
                    style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                          border-radius:3px; cursor:pointer; font-size:16px;"
                    :style="{ opacity: zoomArchivoLevel >= MAX_ZOOM_ARCHIVO ? '0.3' : '0.9' }"
                    title="Acercar">+</button>

                  <button @click.stop="resetZoomArchivo"
                    style="background:none; border:1px solid #666; color:white; padding:2px 6px;
                          border-radius:3px; cursor:pointer; font-size:11px;"
                    title="Restablecer">↺</button>
                </div>

                <!-- Área de la imagen con scroll y drag -->
                <div
                  style="flex: 1; overflow: auto; display: flex; justify-content: flex-start; align-items: flex-start;"
                  :style="{
                    cursor: modoAnotacion
                      ? 'crosshair'
                      : (
                          isDraggingArchivo
                            ? 'grabbing'
                            : (zoomArchivoLevel > 1 ? 'grab' : 'default')
                        )
                  }"
                  @pointerdown="onPointerDownPdfArchivo"
                  @pointermove="onPointerMovePdfArchivo"
                  @pointerup="onPointerUpPdfArchivo"
                  @pointercancel="onPointerUpPdfArchivo"
                >
                  <!-- Imagen con width real -->
                  <div
                    :style="{
                      width: Math.round(zoomArchivoLevel * 100) + '%',
                      minWidth: Math.round(zoomArchivoLevel * 100) + '%',
                      transition: isDraggingArchivo ? 'none' : 'width 0.15s',
                      flexShrink: 0,
                      margin: zoomArchivoLevel <= 1 ? '0 auto' : '0'
                    }"
                  >
                    <img
                      :src="urlPdfVisor"
                      style="width:100%; height:auto; display:block; user-select:none; pointer-events:none;"
                      draggable="false"
                      alt="Documento"
                    />
                  </div>
                </div>
              </div>

            <!-- ✅ Video -->
              <video
                v-else-if="urlPdfVisor && esVideoVisor"
                controls
                preload="auto"
                controlsList="nodownload"
                style="position: absolute; inset: 0; width: 100%; height: 100%; background: #000;"
                @error="onErrorMediaVisor"
              >
                <source :src="urlPdfVisor" :type="mimeVisor" />
              </video>

              <!-- ✅ Audio -->
              <div
                v-else-if="urlPdfVisor && esAudioVisor"
                style="position: absolute; inset: 0; display: flex; flex-direction: column;
                      align-items: center; justify-content: center; background: #2a2a2a;"
              >
                <v-icon size="80" color="white" class="mb-4">mdi-music-note</v-icon>
                <p class="text-white text-body-1 mb-4">{{ archivoContexto?.name || 'Audio' }}</p>
                <audio
                  :src="urlPdfVisor"
                  controls
                  preload="auto"
                  style="width: 80%; max-width: 600px;"
                  @error="onErrorMediaVisor"
                >
                  <source :src="urlPdfVisor" :type="mimeVisor" />
                </audio>
              </div>

              <!-- ══════════════════════════════════════════════ -->
              <!-- MODO MULTI-PÁGINA (sp_sd_doc_paginas_new)       -->
              <!-- ══════════════════════════════════════════════ -->
              <div
                v-else-if="modoPaginasMultiples"
                style="position: absolute; inset: 0; display: flex; flex-direction: column; background: #808080;"
              >

               <!-- Barra de zoom (encima de paginación) -->
              <div
                v-if="urlPaginaMultiple && !cargandoPaginaMultiple && !errorPaginaMultiple"
                style="display: flex; align-items: center; justify-content: center; gap: 8px;
                       padding: 4px 12px; background: #555; flex-shrink: 0;
                       border-bottom: 1px solid #666;"
              >
                <button @click.stop="zoomOutMulti"
                  :disabled="zoomMultiLevel <= MIN_ZOOM_ARCHIVO"
                  style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                        border-radius:3px; cursor:pointer; font-size:16px;"
                  :style="{ opacity: zoomMultiLevel <= MIN_ZOOM_ARCHIVO ? '0.3' : '0.9' }"
                  title="Alejar">−</button>

                <span style="color:white; font-size:12px; min-width:50px; text-align:center;">
                  {{ Math.round(zoomMultiLevel * 100) }}%
                </span>

                <button @click.stop="zoomInMulti"
                  :disabled="zoomMultiLevel >= MAX_ZOOM_ARCHIVO"
                  style="background:none; border:1px solid #666; color:white; padding:2px 8px;
                        border-radius:3px; cursor:pointer; font-size:16px;"
                  :style="{ opacity: zoomMultiLevel >= MAX_ZOOM_ARCHIVO ? '0.3' : '0.9' }"
                  title="Acercar">+</button>

                <button @click.stop="resetZoomMulti"
                  style="background:none; border:1px solid #666; color:white; padding:2px 6px;
                        border-radius:3px; cursor:pointer; font-size:11px;"
                  title="Restablecer">↺</button>
              </div>



                <!-- Barra de navegación -->
                <div style="display: flex; align-items: center; justify-content: center; gap: 8px; padding: 6px 12px; background: #424242; flex-shrink: 0;">
                  
                  <button @click="cargarPaginaMultiple(1)"
                    :disabled="paginaMultipleActual <= 1 || cargandoPaginaMultiple"
                    style="background:none; border:1px solid #666; color:white; padding:2px 8px; border-radius:3px; cursor:pointer; font-size:14px;"
                    :style="{ opacity: paginaMultipleActual <= 1 ? '0.3' : '0.9' }"
                    title="Primera página">«</button>

                  <button @click="cargarPaginaMultiple(paginaMultipleActual - 1)"
                    :disabled="paginaMultipleActual <= 1 || cargandoPaginaMultiple"
                    style="background:none; border:1px solid #666; color:white; padding:2px 8px; border-radius:3px; cursor:pointer; font-size:14px;"
                    :style="{ opacity: paginaMultipleActual <= 1 ? '0.3' : '0.9' }"
                    title="Página anterior">‹</button>

                  <span style="color:white; font-size:12px; min-width:80px; text-align:center;">
                    Pág. {{ paginaMultipleActual }} / {{ listaPaginas.length }}
                  </span>

                  <button @click="cargarPaginaMultiple(paginaMultipleActual + 1)"
                    :disabled="paginaMultipleActual >= listaPaginas.length || cargandoPaginaMultiple"
                    style="background:none; border:1px solid #666; color:white; padding:2px 8px; border-radius:3px; cursor:pointer; font-size:14px;"
                    :style="{ opacity: paginaMultipleActual >= listaPaginas.length ? '0.3' : '0.9' }"
                    title="Página siguiente">›</button>

                  <button @click="cargarPaginaMultiple(listaPaginas.length)"
                    :disabled="paginaMultipleActual >= listaPaginas.length || cargandoPaginaMultiple"
                    style="background:none; border:1px solid #666; color:white; padding:2px 8px; border-radius:3px; cursor:pointer; font-size:14px;"
                    :style="{ opacity: paginaMultipleActual >= listaPaginas.length ? '0.3' : '0.9' }"
                    title="Última página">»</button>

                  <v-progress-circular
                    v-if="cargandoPaginaMultiple"
                    indeterminate color="white" size="16" width="2">
                  </v-progress-circular>
                </div>

                <!-- Área de visualización de la página -->
            
                  <!-- Área de visualización de la página CON zoom + drag -->
        <div
          style="flex:1; overflow:auto; display:flex; justify-content:flex-start;
                align-items:flex-start; padding:8px; background:#808080; position:relative;"
          :style="{ cursor: isDraggingMulti ? 'grabbing' : (zoomMultiLevel > 0.5 ? 'grab' : 'default') }"
            @wheel.prevent="handleZoomWheelMulti"
            @mousedown="onMouseDownMulti"
            @mousemove="onMouseMoveMulti"
            @mouseup="onMouseUpMulti"
            @mouseleave="onMouseUpMulti"
          >


            <!-- Cargando página -->
            <div v-if="cargandoPaginaMultiple"
              style="display:flex; align-items:center; justify-content:center; width:100%; height:100%;">
              <div class="text-center">
                <v-progress-circular indeterminate color="white" size="40"></v-progress-circular>
                <p class="text-white mt-2 text-body-2">Cargando página {{ paginaMultipleActual }}...</p>
              </div>
            </div>

            <!-- Error de página -->
            <div v-else-if="errorPaginaMultiple"
              style="display:flex; align-items:center; justify-content:center; width:100%; height:100%;">
              <div class="text-center">
                <v-icon size="48" color="white">mdi-file-alert-outline</v-icon>
                <p class="text-white mt-2 text-body-2">{{ errorPaginaMultiple }}</p>
              </div>
            </div>

        <!-- Imagen con zoom real (width en lugar de scale) -->
         <div
            v-else-if="urlPaginaMultiple && esImagenPaginaMultiple"
            :style="{
              width: Math.round(zoomMultiLevel * 100) + '%',
              minWidth: Math.round(zoomMultiLevel * 100) + '%',
              transition: isDraggingMulti ? 'none' : 'width 0.15s',
              flexShrink: 0,
              margin: zoomMultiLevel < 1.05 ? '0 auto' : '0 0 0 0'
            }"
          >
            <img
              :src="urlPaginaMultiple"
              style="width:100%; height:auto; box-shadow:0 2px 8px rgba(0,0,0,0.4);
                    user-select:none; pointer-events:none; display:block;"
              draggable="false"
              alt="Página"
            />
          </div>

            <!-- PDF canvas con zoom -->
            <div
              v-else-if="urlPaginaMultiple && !esImagenPaginaMultiple"
              style="margin: 0 auto;"
              :style="{
                transform: `scale(${zoomMultiLevel})`,
                transformOrigin: 'top left',
                transition: isDraggingMulti ? 'none' : 'transform 0.15s',
                flexShrink: 0
              }"
            >
              <canvas
                id="pdf-canvas-multiple"
                style="box-shadow:0 2px 8px rgba(0,0,0,0.4);"
              ></canvas>
            </div>

          </div>

              </div>
          
          <!-- PDF con PDF.js - scroll continuo -->
            <div
              v-else-if="urlPdfVisor && !esImagenVisor && !modoPaginasMultiples"
              ref="pdfCanvasContainer"
              style="position: absolute; inset: 0; display: flex; flex-direction: column; background: #808080;"
            >
              <!-- Barra de paginación -->
              <div style="display: flex; align-items: center; justify-content: center; gap: 8px; padding: 6px 12px; background: #424242; flex-shrink: 0;">
                
                <button
                  @click="irAPaginaScroll(1)"
                  :disabled="paginaActualPdf <= 1"
                  style="background: none; border: 1px solid #666; color: white; padding: 2px 8px; border-radius: 3px; cursor: pointer; font-size: 14px;"
                  :style="{ opacity: paginaActualPdf <= 1 ? '0.3' : '0.9' }"
                  title="Primera página"
                >«</button>

                <button
                  @click="irAPaginaScroll(paginaActualPdf - 1)"
                  :disabled="paginaActualPdf <= 1"
                  style="background: none; border: 1px solid #666; color: white; padding: 2px 8px; border-radius: 3px; cursor: pointer; font-size: 14px;"
                  :style="{ opacity: paginaActualPdf <= 1 ? '0.3' : '0.9' }"
                  title="Página anterior"
                >‹</button>

                <input
                  type="number"
                  :value="paginaActualPdf"
                  @change="irAPaginaInput"
                  :min="1"
                  :max="totalPaginasPdf"
                  style="width: 50px; text-align: center; background: #555; border: 1px solid #666; color: white; padding: 2px 4px; border-radius: 3px; font-size: 12px;"
                />
                
                <span style="color: #ccc; font-size: 12px;">de {{ totalPaginasPdf }}</span>

                <button
                  @click="irAPaginaScroll(paginaActualPdf + 1)"
                  :disabled="paginaActualPdf >= totalPaginasPdf"
                  style="background: none; border: 1px solid #666; color: white; padding: 2px 8px; border-radius: 3px; cursor: pointer; font-size: 14px;"
                  :style="{ opacity: paginaActualPdf >= totalPaginasPdf ? '0.3' : '0.9' }"
                  title="Página siguiente"
                >›</button>

                <button
                  @click="irAPaginaScroll(totalPaginasPdf)"
                  :disabled="paginaActualPdf >= totalPaginasPdf"
                  style="background: none; border: 1px solid #666; color: white; padding: 2px 8px; border-radius: 3px; cursor: pointer; font-size: 14px;"
                  :style="{ opacity: paginaActualPdf >= totalPaginasPdf ? '0.3' : '0.9' }"
                  title="Última página"
                >»</button>

                <v-progress-circular
                  v-if="renderizando"
                  indeterminate
                  color="white"
                  size="16"
                  width="2"
                ></v-progress-circular>
              </div>

              <!-- Contenedor scrollable con TODAS las páginas -->
            <div ref="pdfScrollContainer"
                @scroll="onPdfScroll"
                @click="agregarAnotacion"
                @wheel.stop="handleZoomWheelArchivo"
                :style="{
                  cursor: modoAnotacion ? 'crosshair' : (isDraggingArchivo ? 'grabbing' : (zoomEfectivoArchivo > 1 ? 'grab' : 'default'))
                }"
                style="flex: 1; overflow: auto; background: #808080; padding: 8px 0;"
                @pointerdown="onPointerDownPdfArchivo"
                @pointermove="onPointerMovePdfArchivo"
                @pointerup="onPointerUpPdfArchivo"
                @pointercancel="onPointerUpPdfArchivo"
              >

               <div class="pdf-pages-container">


              <div
                v-for="n in totalPaginasPdf"
                :key="'pdf-page-' + n"
                :ref="el => { if (el) pdfPageRefs[n] = el }"
                :style="{
                  padding: '4px 0',
                  textAlign: 'center',
                  width: zoomArchivoLevel <= 1 ? '100%' : 'fit-content',
                  minWidth: '100%',
                  boxSizing: 'border-box',
                  whiteSpace: 'nowrap'
                }"
              >
                  <div :style="estiloMarcoPagina(n)">
                    <canvas
                      :id="'pdf-canvas-page-' + n"
                      style="width: 100%; height: 100%; display: block; box-shadow: 0 2px 8px rgba(0,0,0,0.4);"
                    ></canvas>
                    <div :id="'pdf-textlayer-page-' + n" class="textLayer" :style="estiloTextLayerPagina(n)"></div>
                  </div>

                </div>

              </div>

            </div>


          </div>
        
      <!-- Sin documento — AGREGAR !modoPaginasMultiples -->
      <div v-if="!urlPdfVisor && !cargandoPdfVisor && !errorPdfVisor && !modoPaginasMultiples && !archivoNoVisualizable"
          style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;">
        <div class="text-center">
          <v-icon size="64" color="white" style="opacity: 0.5;">mdi-file-document-outline</v-icon>
          <p class="text-white mt-2" style="opacity: 0.7;">Sin documento</p>
        </div>
      </div>

          <!-- ===== ANOTACIONES GUARDADAS (Sticky Notes amarillos) ===== -->
          <div
            v-for="(anot, index) in anotaciones"
            :key="'anot-' + index"
            class="sticky-note"
            :style="{
              left: anot.x + '%',
              top: anot.y + '%'
            }"
            @click.stop
          >
            <!-- Barra superior del sticky note -->
            <div class="sticky-note-header">
              <span class="sticky-note-number">#{{ index + 1 }}</span>
              <div class="sticky-note-actions">
                <v-icon
                  size="14"
                  class="sticky-note-btn"
                  @click.stop="editarAnotacion(index)"
                  title="Editar"
                >mdi-pencil</v-icon>
                <v-icon
                  size="14"
                  class="sticky-note-btn sticky-note-btn-delete"
                  @click.stop="eliminarAnotacion(index)"
                  title="Eliminar"
                >mdi-close</v-icon>
              </div>
            </div>
            <!-- Texto de la anotación -->
            <div class="sticky-note-body">
              {{ anot.texto }}
            </div>
          </div>

          <!-- ===== NUEVA ANOTACIÓN (Sticky Note editable) ===== -->
          <div
            v-if="nuevaAnotacionVisible"
            class="sticky-note sticky-note-editing"
            :style="{
              left: nuevaAnotacionX + '%',
              top: nuevaAnotacionY + '%'
            }"
            @click.stop
          >
            <!-- Barra superior -->
            <div class="sticky-note-header">
              <v-icon size="14" style="color: #b8860b;">mdi-plus</v-icon>
              <span style="font-size: 10px; color: #b8860b; font-weight: 600;">Toma una nota...</span>
              <div class="sticky-note-actions">
                <v-icon
                  size="14"
                  class="sticky-note-btn sticky-note-btn-delete"
                  @click.stop="cancelarAnotacion"
                >mdi-close</v-icon>
              </div>
            </div>
            <!-- Textarea editable -->
            <textarea
              id="sticky-note-input"
              v-model="nuevaAnotacionTexto"
              class="sticky-note-textarea"
              placeholder="Escribe tu anotación..."
              rows="4"
              @keydown.enter.ctrl="confirmarAnotacion"
            ></textarea>
            <!-- Botones -->
            <div class="sticky-note-footer">
              <button class="sticky-btn sticky-btn-cancel" @click.stop="cancelarAnotacion">Cancelar</button>
              <button class="sticky-btn sticky-btn-save" @click.stop="confirmarAnotacion">Guardar</button>
            </div>
          </div>

        </div>
      </div>

      <!-- ===== PANEL DERECHO: FORMULARIO ===== -->
      <div style="flex: 3; display: flex; flex-direction: column; min-height: 0; max-height: 100%;">

        <!-- Campos con scroll -->
        <div style="flex: 1; overflow-y: auto; padding: 16px; min-height: 0; max-height: calc(97vh - 120px);">

          <div v-if="cargandoEstructuraArchivo" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p class="mt-2">Cargando estructura...</p>
          </div>

          <v-row v-else dense>
            <v-col v-for="campo in estructuraPlantillaArchivo" :key="campo.column_name" cols="12">
              <v-select
                v-if="campo.valores"
                v-model="valoresIndexacionArchivo[campo.column_name]"
                :items="getOpcionesCombo(campo.valores)"
                :label="campo.column_name"
                variant="outlined" density="compact" clearable
              ></v-select>
              <v-text-field
                v-else-if="esCampoFecha(campo.data_type)"
                v-model="valoresIndexacionArchivo[campo.column_name]"
                :label="campo.column_name"
                type="date" variant="outlined" density="compact" clearable
              ></v-text-field>
              <v-text-field
                v-else
                v-model="valoresIndexacionArchivo[campo.column_name]"
                :label="campo.column_name"
                :maxlength="campo.length"
                variant="outlined" density="compact" clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- ===== LISTA DE ANOTACIONES ===== -->
          <div v-if="anotaciones.length > 0" class="mt-4">
            <v-divider class="mb-2"></v-divider>
            <p class="text-subtitle-2 mb-2">
              <v-icon size="16" class="mr-1">mdi-marker</v-icon>
              Anotaciones ({{ anotaciones.length }})
            </p>
            <v-list density="compact" class="pa-0">
              <v-list-item
                v-for="(anot, index) in anotaciones"
                :key="'lista-anot-' + index"
                class="px-0"
                style="min-height: 36px;"
              >
                <template v-slot:prepend>
                  <v-icon color="orange" size="16">mdi-note</v-icon>
                </template>
                <v-list-item-title class="text-body-2">
                  {{ anot.texto }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  X: {{ anot.x }}% · Y: {{ anot.y }}%
                </v-list-item-subtitle>
                <template v-slot:append>
                  <v-btn
                    icon
                    size="x-small"
                    variant="text"
                    color="error"
                    @click="eliminarAnotacion(index)"
                  >
                    <v-icon size="14">mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-list-item>
            </v-list>
          </div>

        </div>

        <!-- Botones fijos abajo -->
        <div v-if="!modoVisualizacion" class="d-flex align-center justify-space-between px-4 py-3" style="border-top: 1px solid #e0e0e0; flex-shrink: 0;">
          <v-btn color="grey" variant="text" size="small" @click="dialogIndexarArchivo = false">Cancelar</v-btn>
          <v-btn
            color="primary" variant="elevated" size="small"
            @click="guardarIndexacionArchivo"
            :disabled="cargandoEstructuraArchivo"
            :loading="guardandoIndexacion"
          >Guardar</v-btn>
        </div>

      </div>
    </div>

  </v-card>
</v-dialog>

  <!-- ============================================================== -->
  <!-- DIALOG: COMPARTIR ARCHIVO                                      -->
  <!-- ============================================================== -->
  <v-dialog v-model="dialogCompartir" max-width="500px" persistent>
    <v-card>
      <v-card-title class="text-h6 bg-green text-white d-flex align-center">
        <v-icon class="mr-2">mdi-share-variant</v-icon>
        Compartir Archivo
        <v-spacer></v-spacer>
        <v-btn icon size="small" variant="text" @click="dialogCompartir = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-6">
        <v-alert type="info" variant="tonal" class="mb-4">
          <strong>Archivo:</strong> {{ archivoContexto?.name }}
        </v-alert>

        <!-- Selector de usuarios -->
        <v-select
          v-model="usuariosCompartir"
          :items="listaUsuariosCompartir"
          item-title="usuario"
          item-value="idUsuario"
          label="Compartir con"
          variant="outlined"
          density="comfortable"
          multiple
          chips
          closable-chips
          class="mb-4"
        ></v-select>

        <!-- Tipo de permiso -->
        <v-select
          v-model="permisoCompartir"
          :items="tiposPermisoCompartir"
          item-title="nombre"
          item-value="id"
          label="Tipo de permiso"
          variant="outlined"
          density="comfortable"
        ></v-select>

        <v-divider class="my-4"></v-divider>
        
        <!-- Generar enlace -->
        <v-btn
          color="primary"
          variant="outlined"
          block
          @click="generarEnlaceCompartir"
          :loading="generandoEnlace"
        >
          <v-icon class="mr-2">mdi-link</v-icon>
          Generar enlace de descarga
        </v-btn>

        <v-text-field
          v-if="enlaceCompartir"
          v-model="enlaceCompartir"
          label="Enlace generado"
          variant="outlined"
          density="comfortable"
          readonly
          class="mt-4"
          append-inner-icon="mdi-content-copy"
          @click:append-inner="copiarEnlace"
        ></v-text-field>
      </v-card-text>

      <v-card-actions class="px-6 pb-4">
        <v-btn color="grey" variant="text" @click="dialogCompartir = false">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          variant="elevated"
          @click="confirmarCompartir"
          :disabled="usuariosCompartir.length === 0"
        >
          Compartir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <!-- ============================================================== -->
  <!-- DIALOG: GENERAR OCR                                            -->
  <!-- ============================================================== -->
  <v-dialog v-model="dialogOCR" max-width="600px" persistent>
    <v-card>
      <v-card-title class="text-h6 text-white d-flex align-center" style="background-color: #004d82;">
        <v-icon class="mr-2">mdi-text-recognition</v-icon>
        Generar OCR
        <v-spacer></v-spacer>
        <v-btn icon size="small" variant="text" @click="dialogOCR = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-6">
        <v-alert type="info" variant="tonal" class="mb-4">
          <strong>Archivo:</strong> {{ archivoContexto?.name }}
        </v-alert>


        <!-- Barra de progreso -->
        <div v-if="procesandoOCR" class="mt-4">
          <p class="text-body-2 mb-2">Procesando OCR...</p>
          <v-progress-linear
            v-model="progresoOCR"
            color="#ce501b"
            height="20"
            striped
          >
            <template v-slot:default>
              {{ Math.round(progresoOCR) }}%
            </template>
          </v-progress-linear>
        </div>

        <!-- Resultado OCR -->
        <v-textarea
          v-if="resultadoOCR"
          ref="textareaOCR"
          v-model="resultadoOCR"
          label="Texto extraído"
          variant="outlined"
          rows="8"
          readonly
          class="mt-4"
        ></v-textarea>
      </v-card-text>

      <v-card-actions class="px-6 pb-4">
        <v-btn color="#9B9B9B" variant="text" @click="dialogOCR = false">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="resultadoOCR"
          color="#ce501b"
          variant="outlined"
          @click="copiarTextoOCR"
          class="mr-2"
        >
          <v-icon class="mr-1">mdi-content-copy</v-icon>
          Copiar texto
        </v-btn>
        <v-btn
          color="#ce501b"
          variant="elevated"
          @click="ejecutarOCR"
          :loading="procesandoOCR"
          :disabled="procesandoOCR"
        >
          {{ resultadoOCR ? 'Procesar de nuevo' : 'Iniciar OCR' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>





<!-- ============================================================== -->
<!-- DIALOG: LISTADO DE VERSIONES                                   -->
<!-- ============================================================== -->
<v-dialog v-model="dialogVersiones" max-width="950px" persistent>
  <v-card>
    <!-- Header azul como en la imagen -->
    <v-card-title class="text-subtitle-1 text-white py-2 px-4 d-flex align-center" style="background-color: #004d82;">
      Listado de versiones
      <v-spacer></v-spacer>
      <v-btn icon size="small" variant="text" @click="dialogVersiones = false">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-4">
      <!-- Botón Nueva Versión -->
      <div class="mb-3">
        <v-btn
          color="primary"
          variant="text"
          size="small"
          prepend-icon="mdi-plus"
          @click="nuevaVersion"
        >
          Nueva Versión
        </v-btn>
      </div>

      <!-- Tabla de versiones -->
      <v-data-table
        :headers="headersVersiones"
        :items="versionesPaginadas"
        :loading="cargandoVersiones"
        density="compact"
        class="elevation-1 tabla-versiones"
        no-data-text="Ningún dato disponible en esta tabla"
        hide-default-footer
      >
        <!-- Fila con click derecho -->
        <template v-slot:item="{ item }">
          <tr 
            @contextmenu.prevent="abrirMenuVersion($event, item)"
            class="fila-version"
            :class="{ 'fila-version-seleccionada': versionSeleccionada?.item === item.item }"
          >
            <td>{{ item.usuario }}</td>
            <td>{{ formatearFechaVersion(item.fecha) }}</td>
            <td>{{ formatearPeso(item.peso) }}</td>
            <td>{{ item.version }}</td>
            <td>{{ item.ip }}</td>
          </tr>
        </template>
      </v-data-table>

      <!-- Paginación personalizada -->
      <div class="d-flex align-center justify-space-between pa-2 mt-2" style="border: 1px solid #e0e0e0; border-top: none; background-color: #fafafa;">
        <span class="text-caption text-grey-darken-1">
          Mostrando registros del {{ rangoInicio }} al {{ rangoFin }} de un total de {{ versionesArchivo.length }} registros
        </span>
        
        <div class="d-flex align-center ga-1">
          <!-- Botón Primero -->
          <v-btn
            variant="outlined"
            size="x-small"
            :disabled="paginaActual === 1"
            @click="paginaActual = 1"
            class="pagination-btn"
          >
            Primero
          </v-btn>
          
          <!-- Números de página -->
          <template v-for="pagina in paginasVisibles" :key="pagina">
            <v-btn
              :variant="pagina === paginaActual ? 'flat' : 'outlined'"
              :color="pagina === paginaActual ? '#004d82' : undefined"
              size="x-small"
              min-width="32"
              @click="paginaActual = pagina"
              class="pagination-btn"
            >
              {{ pagina }}
            </v-btn>
          </template>
          
          <!-- Botón Último -->
          <v-btn
            variant="outlined"
            size="x-small"
            :disabled="paginaActual === totalPaginas"
            @click="paginaActual = totalPaginas"
            class="pagination-btn"
          >
            Último
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
</v-dialog>



<!-- ============================================================== -->
<!-- MENÚ CONTEXTUAL PARA VERSIONES (Click Derecho)                 -->
<!-- ============================================================== -->
<v-menu
  v-model="showMenuVersion"
  :style="{ left: menuVersionX + 'px', top: menuVersionY + 'px' }"
  absolute
  offset-y
  :close-on-content-click="true"
>
  <v-list density="compact" nav class="menu-contextual-version">
   
    <!-- Descargar formato original -->
    <v-list-item @click="descargarVersionOriginal" class="menu-item-version">
      <template v-slot:prepend>
        <v-icon color="success" size="small">mdi-download</v-icon>
      </template>
      <v-list-item-title>Descargar formato original</v-list-item-title>
    </v-list-item>

  </v-list>
</v-menu>


<!-- ============================================================== -->
<!-- DIALOG: NUEVA VERSIÓN (Importar archivo)                       -->
<!-- ============================================================== -->
<v-dialog v-model="dialogNuevaVersion" max-width="550px" persistent>
  <v-card>
    <!-- Header -->
    <v-card-title class="text-subtitle-1 text-white py-2 px-4 d-flex align-center" style="background-color: #004d82;">
      Importar nueva versión
      <v-spacer></v-spacer>
      <v-btn icon size="small" variant="text" @click="cerrarDialogNuevaVersion">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-0">
      <!-- Encabezado de tabla -->
      <div class="d-flex tabla-header">
        <div class="flex-grow-1 pa-2" style="border-right: 1px solid #e0e0e0;">
          Nombre de archivo
        </div>
        <div class="pa-2 text-center" style="width: 100px; border-right: 1px solid #e0e0e0;">
          Tamaño
        </div>
        <div class="pa-2 text-center" style="width: 100px;">
          Estado
        </div>
      </div>

      <!-- Zona de arrastrar archivos / Lista de archivos -->
      <div 
        class="drop-zone"
        :class="{ 'drop-zone-active': isDragging }"
        @dragover.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @drop.prevent="handleDrop"
      >
        <!-- Si no hay archivos, mostrar mensaje -->
        <div v-if="archivosNuevaVersion.length === 0" class="text-center text-grey py-10">
          <v-icon size="40" color="grey-lighten-1" class="mb-2">mdi-cloud-upload-outline</v-icon>
          <p>Arrastre archivos aquí.</p>
        </div>

        <!-- Lista de archivos seleccionados -->
          <div v-else>
            <div 
              v-for="(archivo, index) in archivosNuevaVersion" 
              :key="index"
              class="d-flex archivo-row align-center"
            >
              <div class="flex-grow-1 pa-2 text-truncate" style="border-right: 1px solid #e0e0e0;">
                {{ archivo.name }}
              </div>
              <div class="pa-2 text-center" style="width: 100px; border-right: 1px solid #e0e0e0;">
                {{ formatearTamano(archivo.size) }}
              </div>
              <div class="pa-2 text-center d-flex align-center justify-center" style="width: 100px;">
                <v-chip 
                  :color="getEstadoColor(archivo.estado)" 
                  size="x-small"
                  label
                  class="mr-1"
                >
                  {{ archivo.estado }}
                </v-chip>
                <!-- Botón eliminar (solo si no está subiendo) -->
                <v-btn
                  v-if="!subiendoVersion && archivo.estado === 'Pendiente'"
                  icon
                  size="x-small"
                  variant="text"
                  color="error"
                  @click="eliminarArchivoLista(index)"
                >
                  <v-icon size="small">mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </div>

      </div>

      <!-- Barra inferior con botones y progreso -->
      <div class="d-flex align-center pa-3" style="border-top: 1px solid #e0e0e0; background-color: #f5f5f5;">
        <!-- Botón Add files -->
        <v-btn
          variant="outlined"
          size="small"
          color="grey-darken-2"
          prepend-icon="mdi-plus"
          @click="abrirSelectorArchivos"
          :disabled="subiendoVersion"
          class="mr-2"
        >
          Add files
        </v-btn>

        <!-- Input file oculto -->
       <!-- Input file oculto (agregar multiple) -->
        <input
          ref="inputArchivoVersion"
          type="file"
          multiple
          style="display: none;"
          @change="handleFileSelect"
        />

        <!-- Botón Comenzar Subida -->
        <v-btn
          variant="outlined"
          size="small"
          color="primary"
          prepend-icon="mdi-check"
          @click="subirNuevaVersion"
          :disabled="archivosNuevaVersion.length === 0 || subiendoVersion"
          :loading="subiendoVersion"
        >
          Comenzar Subida
        </v-btn>

        <v-spacer></v-spacer>

        <!-- Tamaño total y porcentaje -->
        <span class="text-caption mr-4">{{ tamanoTotalArchivos }}</span>
        <span class="text-caption">{{ progresoSubida }}%</span>
      </div>

      <!-- Barra de progreso -->
      <v-progress-linear
        v-if="subiendoVersion"
        :model-value="progresoSubida"
        color="primary"
        height="4"
      ></v-progress-linear>
    </v-card-text>
  </v-card>
</v-dialog>


<!-- ============================================================== -->
<!-- DIALOG: EXPORTAR ARCHIVO                                       -->
<!-- ============================================================== -->

<v-dialog v-model="dialogExportar" max-width="450px" persistent>
  <v-card>
    <!-- Header -->
    <v-card-title class="text-subtitle-1 bg-grey-lighten-3 py-2 px-4 d-flex align-center justify-space-between" style="border-bottom: 1px solid #e0e0e0;">
      Exportar
      <v-btn icon size="small" variant="text" @click="dialogExportar = false">
        <v-icon size="small">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-4 pb-2">
      <!-- Info del archivo -->
      <p class="mb-4">
        Archivo "<strong>{{ archivoContexto?.name }}</strong>" sera exportada.
      </p>

      <!-- Campo Desde -->
      <v-row align="center" class="mb-2">
        <v-col cols="3" class="py-1">
          <span class="text-body-2">Desde</span>
        </v-col>
        <v-col cols="9" class="py-1">
          <v-select
            v-model="exportarDesde"
            :items="opcionesPaginas"
            item-title="texto"
            item-value="valor"
            variant="outlined"
            density="compact"
            hide-details
            placeholder="Select an Option"
          ></v-select>
        </v-col>
      </v-row>

      <!-- Campo Hasta -->
      <v-row align="center" class="mb-3">
        <v-col cols="3" class="py-1">
          <span class="text-body-2">Hasta</span>
        </v-col>
        <v-col cols="9" class="py-1">
          <v-select
            v-model="exportarHasta"
            :items="opcionesPaginasHasta"
            item-title="texto"
            item-value="valor"
            variant="outlined"
            density="compact"
            hide-details
            placeholder="Select an Option"
          ></v-select>
        </v-col>
      </v-row>

      <!-- Checkbox Con certificado -->
      <v-checkbox
        v-model="exportarConCertificado"
        label="Con certificado"
        density="compact"
        hide-details
        class="mt-2"
      ></v-checkbox>
    </v-card-text>

    <v-card-actions class="px-4 pb-4 pt-2">
      <v-btn
        variant="outlined"
        color="grey-darken-1"
        @click="dialogExportar = false"
      >
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        variant="flat"
        color="primary"
        @click="confirmarExportar"
        :loading="exportandoArchivo"
      >
        Exportar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

  <!-- End entorno grafico Front-end -->
</template>

<script setup>
/* eslint-disable no-undef */
//el script setup es propio de Vue 3 sirve para la Composition API
//Breve explicación del funcionamiento del codigo : 
//Este codigo esta basado en arboles y grafos, es importante estudiar ese tema para poder entender con mayor claridad  
//El porque se hizo así fue para optimizar la carga y sea mucho más rápido ya que de esa forma solo va cargar por nodos de padre y hijo
//Tener en cuenta esto: 
//TocId de la tabla toc .- Es el identificador único de carpeta o archivo
//ParentId de la tabla toc .- Indica quien es su carpeta padre (tocId es el nodo que lo contiene)
//A continuación vamos a ver el codigo
//Aquí empieza la programación para cargar nuestro entorno gráfico con las APIS usando los grafos por NODO
import { ref, computed, onMounted, onUnmounted, defineEmits, nextTick, shallowRef, watch  } from 'vue'; //Estas importación nos sirve para la Composition API.
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';

//ref .- Si queremos variables reactivas el ref nos permite eso pero solo da para estos tipos de datos primitivos y algunas estucturas como objetos o arrays
//computed .- Sirve para calcular propiedades calculadas y reactivas, tener encuenta que su valor depende de otras variables reactivas: ref, reactive, etc.
//onMounted .- Sirve para cargar datos al iniciar 

import axios from '@/plugins/axios'
import Swal from 'sweetalert2';
import { buildApiUrl } from '@/config/api'

import UTIF from 'utif';
import * as XLSX from 'xlsx';

import { useImportarMinimizado } from './useImportarMinimizado'
import { useDescargas } from './Usedescargas'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const zoomArchivoLevel = ref(1);

const dimsBasePaginas = ref({});   // {n: {w, h}} tamaño de cada página a zoom 100%
const zoomRenderPagina = ref({});  // {n: zoom al que está renderizado su canvas}

const MIN_ZOOM_ARCHIVO = 0.5
const MAX_ZOOM_ARCHIVO = 3
const ZOOM_RENDER_DEBOUNCE_MS = 180
const zoomEfectivoArchivo = computed(() =>
  Math.min(MAX_ZOOM_ARCHIVO, Math.max(MIN_ZOOM_ARCHIVO, zoomArchivoLevel.value))
)
const isDraggingArchivo = ref(false)
const dragStartXArchivo = ref(0)
const dragStartYArchivo = ref(0)
const scrollStartXArchivo = ref(0)
const scrollStartYArchivo = ref(0)
let pointerIdArrastrePdf = null

const zoomInArchivo  = () => aplicarZoomEnPunto(Math.min(zoomArchivoLevel.value + 0.25, MAX_ZOOM_ARCHIVO));
const zoomOutArchivo = () => aplicarZoomEnPunto(Math.max(zoomArchivoLevel.value - 0.25, MIN_ZOOM_ARCHIVO));

const resetZoomArchivo = () => aplicarZoomEnPunto(1)


const estiloMarcoPagina = (n) => {
  const d = dimsBasePaginas.value[n] || dimsBasePaginas.value[1];
  if (!d) return { position: 'relative', display: 'inline-block', verticalAlign: 'top' };
  const z = zoomEfectivoArchivo.value;
  return {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'top',
    width: (d.w * z) + 'px',
    height: (d.h * z) + 'px',
    overflow: 'hidden'
  };
};


const estiloTextLayerPagina = (n) => {
  const zoomRenderizado = zoomRenderPagina.value[n] || 1;
  // El text layer se renderizó para el zoom zr; escalarlo al zoom actual
  return {
    transform: `scale(${zoomEfectivoArchivo.value / zoomRenderizado})`,
    transformOrigin: '0 0'
  };
};



// ── Zoom + Drag para modo Multi-Página ──
const zoomMultiLevel = ref(1)
const isDraggingMulti = ref(false)
const dragStartXMulti = ref(0)
const dragStartYMulti = ref(0)
const scrollStartXMulti = ref(0)
const scrollStartYMulti = ref(0)

const zoomInMulti  = () => { zoomMultiLevel.value = Math.min(zoomMultiLevel.value + 0.25, MAX_ZOOM_ARCHIVO) }
const zoomOutMulti = () => { zoomMultiLevel.value = Math.max(zoomMultiLevel.value - 0.25, MIN_ZOOM_ARCHIVO) }
const resetZoomMulti = () => { zoomMultiLevel.value = 1 }

const handleZoomWheelMulti = (event) => {
  zoomMultiLevel.value = event.deltaY < 0
    ? Math.min(zoomMultiLevel.value + 0.1, MAX_ZOOM_ARCHIVO)
    : Math.max(zoomMultiLevel.value - 0.1, MIN_ZOOM_ARCHIVO)
}

const onMouseDownMulti = (event) => {
  if (zoomMultiLevel.value <= 1.05) return
  isDraggingMulti.value = true
  dragStartXMulti.value = event.clientX
  dragStartYMulti.value = event.clientY
  const el = event.currentTarget
  scrollStartXMulti.value = el.scrollLeft
  scrollStartYMulti.value = el.scrollTop
  event.preventDefault()
}

const onMouseMoveMulti = (event) => {
  if (!isDraggingMulti.value) return
  const el = event.currentTarget
  if (!el) return
  el.scrollLeft = scrollStartXMulti.value - (event.clientX - dragStartXMulti.value)
  el.scrollTop  = scrollStartYMulti.value - (event.clientY - dragStartYMulti.value)
}

const onMouseUpMulti = () => { isDraggingMulti.value = false }

const handleZoomWheelArchivo = (event) => {
  if (!urlPdfVisor.value) return
  if (esVideoVisor.value || esAudioVisor.value) return

  // ✅ Si es PDF (no imagen): solo zoom con Ctrl, sin Ctrl deja scroll natural de páginas
  if (!esImagenVisor.value) {
    if (!event.ctrlKey) return  // sin Ctrl → scroll de páginas natural
    event.preventDefault()
  } else {
    // ✅ Si es imagen: zoom directo con la rueda (sin necesidad de Ctrl)
    event.preventDefault()
  }

  const rect = event.currentTarget.getBoundingClientRect();
  const puntoX = event.clientX - rect.left;
  const puntoY = event.clientY - rect.top;

  const nuevo = event.deltaY < 0
    ? Math.min(zoomArchivoLevel.value + 0.1, MAX_ZOOM_ARCHIVO)
    : Math.max(zoomArchivoLevel.value - 0.1, MIN_ZOOM_ARCHIVO);

  aplicarZoomEnPunto(nuevo, puntoX, puntoY);
}


const onPointerDownPdfArchivo = (event) => {
  if (event.button !== 0 || zoomEfectivoArchivo.value <= 1 || modoAnotacion.value) return
  if (event.target.closest?.('.textLayer span')) return
  isDraggingArchivo.value = true
  pointerIdArrastrePdf = event.pointerId
  dragStartXArchivo.value = event.clientX
  dragStartYArchivo.value = event.clientY
  const el = event.currentTarget
  scrollStartXArchivo.value = el.scrollLeft
  scrollStartYArchivo.value = el.scrollTop
  el.setPointerCapture(event.pointerId)
  event.preventDefault()
}

const onPointerMovePdfArchivo = (event) => {
  if (!isDraggingArchivo.value || event.pointerId !== pointerIdArrastrePdf) return
  const el = event.currentTarget
  if (!el) return
  el.scrollLeft = scrollStartXArchivo.value - (event.clientX - dragStartXArchivo.value)
  el.scrollTop  = scrollStartYArchivo.value - (event.clientY - dragStartYArchivo.value)
}

const onPointerUpPdfArchivo = (event) => {
  if (event.pointerId !== pointerIdArrastrePdf) return
  const el = event.currentTarget
  if (el?.hasPointerCapture?.(event.pointerId)) el.releasePointerCapture(event.pointerId)
  isDraggingArchivo.value = false
  pointerIdArrastrePdf = null
}


const esTiffVisor = ref(false);

const modoVisualizacion = ref(false);
const AccesoExportar = ref(false);
const AccesoAnotacion = ref(false);
const AccesoImprimir = ref(false);
const anotaciones = ref([]);
const modoAnotacion = ref(false);

// Variable para total de páginas
//const totalPaginasPdf = ref(0);

// ✅ PONER
const totalPaginasPdf = ref(0);
const paginaActualPdf = ref(1);
const pdfDocumento = shallowRef(null);// guarda la instancia del PDF
const renderizando = ref(false);

//nuevas variables 

const pdfScrollContainer = ref(null);
const pdfPageRefs = ref({});
const paginasRenderizadas = ref(new Set());
const textContentCacheArchivo = ref({});
const scrollUpdateLock = ref(false);

// Nuevas variables para sticky note inline
const nuevaAnotacionVisible = ref(false);
const nuevaAnotacionX = ref(0);
const nuevaAnotacionY = ref(0);
const nuevaAnotacionTexto = ref('');
const editandoAnotacionIndex = ref(null); // para editar una existente

// Agregar junto a las otras variables del visor
const esImagenVisor = ref(false);
const esVideoVisor = ref(false);    // ✅ NUEVO
const esAudioVisor = ref(false);    // ✅ NUEVO
const mimeVisor = ref('');          // ✅ NUEVO

const extensionesVideo = ['mp4', 'webm', 'ogg', 'mov', 'mkv', 'avi'];
const extensionesAudioVisor = ['mp3', 'wav', 'm4a', 'ogg', 'aac'];

const urlPdfVisor    = ref('');
const cargandoPdfVisor = ref(false);
const errorPdfVisor  = ref('');
const archivoNoVisualizable = ref(false);

const textoMenuIndexacion = ref('Indexación');
const carpetasPadre = ref([]); //Lista de carpeta raíz
const search = ref(''); //variable para el filtro de busqueda de carpetas y archivos
const caseSensitive = ref(false); //variable para el check sensitivo a mayuscula
const treeData = ref([]); // datos estructurados del árbol de carpetas y subcarpetas anidadas
const subcarpetasCache = ref(new Map()); // Evita volver a pedir subcarpetas al servidor, si ya fueron cargadas antes 
const openedGroups = ref([0]); // El directorio principal (tocId=0) inicia abierto
const loadingNodes = ref(new Set()); // Sirve para mostrar estado de carga en nodos individuales
const movingFolder = ref(false);
const selectedFolder = ref(null); // Cambiado a null en lugar de array
const selectedFolderTemplateId = ref(null); // ✅ AGREGAR ESTO
const filesInSelectedFolder = ref([]); //variable que almacena la lista folder seleccionado
const loadingFiles = ref(false); //Identificador de carga de archivo

const buscarArchivo = ref('');

const esTipoPer = ref(0)   // 0 = sin acceso, 1 = lectura, 2 = escritura
const esAdmin = ref(false)

const puedeEscribir = computed(() => esTipoPer.value === 2 || esAdmin.value)
const puedeLeer     = computed(() => esTipoPer.value >= 1 || esAdmin.value)

// Lista completa de permisos del usuario en sesión (la misma que usa tree-node)
const permisosCarpetas = ref([])



const { pendingReloadTocId } = useImportarMinimizado()
const { procesarDescargaArchivo } = useDescargas()

const sincronizarTablaTrasImport = async (tocIdRecargar) => {
  if (!tocIdRecargar) return
  // Solo refresca si es la carpeta que el usuario tiene abierta AHORA MISMO
  if (selectedFolder.value?.tocId === tocIdRecargar) {
    await loadFilesForFolder(tocIdRecargar)
  }
}

watch(pendingReloadTocId, (newTocId) => {
  sincronizarTablaTrasImport(newTocId)
  // Nota: no lo ponemos en null aquí — treeNode.vue sigue siendo
  // quien "consume" y limpia la señal, como ya lo hacía.
})



// ── Re-renderizar PDF cuando cambia el zoom ──
// ── Re-renderizar PDF cuando cambia el zoom (preservando posición) ──
let zoomDebounceTimer = null;


watch(zoomArchivoLevel, (nuevoZoom) => {
  if (!pdfDocumento.value || esImagenVisor.value || modoPaginasMultiples.value) return;
  if (zoomDebounceTimer) clearTimeout(zoomDebounceTimer);
  zoomDebounceTimer = setTimeout(() => reRenderizarPorZoom(nuevoZoom), ZOOM_RENDER_DEBOUNCE_MS);
});



const reRenderizarPorZoom = async (nuevoZoom) => {
  const docActual = pdfDocumento.value;
  if (!docActual) return;

  const tareas = Object.values(renderTasks.value);
  renderTasks.value = {};
  for (const task of tareas) {
    try { task.cancel(); } catch (e) { void e; }
  }
  await Promise.allSettled(tareas.map(task => task?.promise));
  paginasRenderizadas.value = new Set();

  const actual = paginaActualPdf.value;
  try { await renderizarPaginaPdf(actual); } catch (e) { void e; }

  (async () => {
    const buffer = 1;
    const desde = Math.max(1, actual - buffer);
    const hasta = Math.min(totalPaginasPdf.value, actual + buffer);
    for (let i = desde; i <= hasta; i++) {
      if (i === actual) continue;
      if (pdfDocumento.value !== docActual || zoomArchivoLevel.value !== nuevoZoom) return;
      try { await renderizarPaginaPdf(i); } catch (e) { void e; }
    }
  })();
};

// Headers y datos de la tabla
const fileHeaders = ref([
  { title: 'Nombre', key: 'name', sortable: true },
  { title: 'Peso', key: 'peso', sortable: true }
  //{ title: 'Acciones', key: 'actions', sortable: false, width: '120px' }
]);


const onErrorMediaVisor = (event) => {
  // MEDIA_ERR_ABORTED (code 1) es normal al hacer seek — ignorar
  if (event.target?.error?.code === 1) return
  // Otros errores reales
  console.warn('Error en reproductor:', event.target?.error)
}



const handleFolderDeleted = (deletedTocId) => {
  // Si la carpeta eliminada era la seleccionada, limpiar el panel derecho
  if (selectedFolder.value?.tocId === deletedTocId) {
    selectedFolder.value = null;
    selectedFolderTemplateId.value = null;
    filesInSelectedFolder.value = [];
    estructuraDinamica.value = [];
    // Restaurar headers base
    fileHeaders.value = [
      { title: 'Nombre', key: 'name', sortable: true },
      { title: 'Peso', key: 'peso', sortable: true }
    ];
  }
};


const archivosFiltrados = computed(() => {
  if (!buscarArchivo.value || !buscarArchivo.value.trim()) {
    return filesInSelectedFolder.value;
  }

  const texto = buscarArchivo.value.toLowerCase().trim();

  return filesInSelectedFolder.value.filter(archivo => {
    // Buscar en el nombre del archivo
    if (archivo.name && archivo.name.toLowerCase().includes(texto)) {
      return true;
    }

    // Buscar en cada campo dinámico (nombre, edad, fecha, sexo, etc.)
    for (const campo of estructuraDinamica.value) {
      const valor = archivo['dyn_' + campo.column_name];
      if (valor !== null && valor !== undefined && String(valor).toLowerCase().includes(texto)) {
        return true;
      }
    }

    // Buscar también en el peso, por si acaso
    if (archivo.peso !== null && archivo.peso !== undefined && String(archivo.peso).toLowerCase().includes(texto)) {
      return true;
    }

    return false;
  });
});


const estructuraDinamica = ref([]);

const renderizarPdfJs = async (url) => {
  // ✅ Cancelar Y ESPERAR todos los renders activos
  const tareasActivas = Object.values(renderTasks.value);
  for (const task of tareasActivas) {
    try { if (task?.cancel) task.cancel() } catch (e) { void e }
  }
  await Promise.allSettled(
    tareasActivas.map(t => {
      try { return t?.promise ? t.promise.catch(() => null) : Promise.resolve() }
      catch (e) { void e; return Promise.resolve() }
    })
  )
  renderTasks.value = {};

  const pdfAnterior = pdfDocumento.value;
  if (pdfAnterior) {
    pdfDocumento.value = null;
    await pdfAnterior.destroy?.();
  }

  const loadingTask = pdfjsLib.getDocument(url);
  const pdf = await loadingTask.promise;

  pdfDocumento.value = pdf;

  // ✅ Layout determinista: tamaño base de cada página, disponible ANTES de renderizar
  const vpo1 = (await pdf.getPage(1)).getViewport({ scale: 1 });
  const cont = pdfScrollContainer.value;
  const anchoCont = cont ? cont.clientWidth : 800;
  const escalaBase = (anchoCont - 24) / vpo1.width;

  const dims = {};
  for (let n = 1; n <= pdf.numPages; n++) {
    dims[n] = { w: vpo1.width * escalaBase, h: vpo1.height * escalaBase };
  }
  dimsBasePaginas.value = dims;
  zoomRenderPagina.value = {};

  // Corregir tamaños reales en segundo plano (por si hay páginas de distinto tamaño)
  (async () => {
    for (let n = 2; n <= pdf.numPages; n++) {
      if (pdfDocumento.value !== pdf) return;
      const vpo = (await pdf.getPage(n)).getViewport({ scale: 1 });
      dimsBasePaginas.value[n] = { w: vpo.width * escalaBase, h: vpo.height * escalaBase };
    }
  })();

  totalPaginasPdf.value = pdf.numPages;
  paginaActualPdf.value = 1;
  paginasRenderizadas.value = new Set();
  textContentCacheArchivo.value = {};
  pdfPageRefs.value = {};

  await nextTick();
  await nextTick();

  const paginasIniciales = Math.min(pdf.numPages, 5);
  for (let i = 1; i <= paginasIniciales; i++) {
    await renderizarPaginaPdf(i);
  }

  cargandoPdfVisor.value = false;
};

// PDF.js usa campos privados; las tareas no deben pasar por el proxy reactivo de Vue.
const renderTasks = shallowRef({});  // guarda el renderTask activo por página


const renderizarPaginaPdf = async (numeroPagina) => {
  if (!pdfDocumento.value) return;
  if (paginasRenderizadas.value.has(numeroPagina)) return;

  const pdfAlIniciar = pdfDocumento.value;
  const zoomAlIniciar = zoomEfectivoArchivo.value;

  if (renderTasks.value[numeroPagina]) {
    try {
      renderTasks.value[numeroPagina].cancel();
      await renderTasks.value[numeroPagina].promise;
    } catch (e) { void e; }
    delete renderTasks.value[numeroPagina];
  }

  renderizando.value = true;
  try {
    const page = await pdfAlIniciar.getPage(numeroPagina);
    const canvas = document.getElementById('pdf-canvas-page-' + numeroPagina);
    if (!canvas) return;

    const contenedor = pdfScrollContainer.value;
    const anchoContenedor = contenedor ? contenedor.clientWidth : 800;

    const viewportOriginal = page.getViewport({ scale: 1 });
    const escalaBase = (anchoContenedor - 24) / viewportOriginal.width;
    const escalaFinal = escalaBase * zoomAlIniciar;
    const viewport = page.getViewport({ scale: escalaFinal });

    // ✅ Canvas TEMPORAL para renderizar limpio
    const canvasTmp = document.createElement('canvas');
    canvasTmp.width = viewport.width;
    canvasTmp.height = viewport.height;
    const ctxTmp = canvasTmp.getContext('2d');
    ctxTmp.setTransform(1, 0, 0, 1, 0, 0);
    ctxTmp.clearRect(0, 0, canvasTmp.width, canvasTmp.height);

    const renderTask = page.render({ canvasContext: ctxTmp, viewport });
    renderTasks.value[numeroPagina] = renderTask;

    await renderTask.promise;

    if (
      pdfDocumento.value !== pdfAlIniciar ||
      zoomEfectivoArchivo.value !== zoomAlIniciar
    ) {
      return;
    }

    // ✅ Solo copiar al canvas real DESPUÉS de que terminó limpio
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    const ctx = canvas.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(canvasTmp, 0, 0);

   zoomRenderPagina.value[numeroPagina] = zoomAlIniciar;

       // ✅ NUEVO: Text layer para permitir seleccionar texto
  // ✅ NUEVO: Text layer para permitir seleccionar texto
    const textLayerDiv = document.getElementById('pdf-textlayer-page-' + numeroPagina);
    if (textLayerDiv) {
      textLayerDiv.innerHTML = ''; // limpiar por si se re-renderiza (zoom)
      textLayerDiv.style.width = viewport.width + 'px';
      textLayerDiv.style.height = viewport.height + 'px';
      textLayerDiv.style.setProperty('--scale-factor', viewport.scale);

      let textContent = textContentCacheArchivo.value[numeroPagina];
      if (!textContent) {
        textContent = await page.getTextContent();
        textContentCacheArchivo.value[numeroPagina] = textContent;
      }

      const textDivs = [];

      await pdfjsLib.renderTextLayer({
        textContent: textContent,
        container: textLayerDiv,
        viewport: viewport,
        textDivs: textDivs
      }).promise;

      // ✅ Corrección manual de anchos: forzar que cada span mida
      // EXACTAMENTE lo que mide el texto pintado en el canvas
      textContent.items.forEach((item, i) => {
        const div = textDivs[i];
        if (!div || !item.str || !item.str.trim() || !item.width) return;

        const anchoObjetivo = item.width * viewport.scale; // ancho real pintado en px
        const anchoNatural = div.offsetWidth;              // ancho del span sin transform

        if (anchoNatural > 0 && !(div.style.transform || '').includes('rotate')) {
          div.style.transform = `scaleX(${anchoObjetivo / anchoNatural})`;
        }
      });

      // ✅ Fix de selección (truco endOfContent del visor oficial de PDF.js)
      const endOfContent = document.createElement('div');
      endOfContent.className = 'endOfContent';
      textLayerDiv.appendChild(endOfContent);

      textLayerDiv.addEventListener('mousedown', (e) => {
        if (!e.target.closest('span')) return
        endOfContent.classList.add('active');
        document.addEventListener(
          'mouseup',
          () => endOfContent.classList.remove('active'),
          { once: true }
        );
      });

    }

    paginasRenderizadas.value.add(numeroPagina);
    delete renderTasks.value[numeroPagina];

  } catch (error) {
    if (error?.name !== 'RenderingCancelledException') {
      console.error(`Error al renderizar página ${numeroPagina}:`, error);
    }
  } finally {
    renderizando.value = false;
  }
};


// ── Detectar página visible al hacer scroll (lazy render) ──
const onPdfScroll = () => {
  if (scrollUpdateLock.value) return;

  const container = pdfScrollContainer.value;
  if (!container) return;

  const scrollTop = container.scrollTop;
  const containerHeight = container.clientHeight;
  const scrollCenter = scrollTop + containerHeight / 2;

  let paginaVisible = 1;
  let mejorDistancia = Infinity;

  for (let n = 1; n <= totalPaginasPdf.value; n++) {
    const wrapper = pdfPageRefs.value[n];
    if (!wrapper) continue;

    const offsetTop = wrapper.offsetTop;
    const height = wrapper.offsetHeight;
    const centro = offsetTop + height / 2;
    const distancia = Math.abs(scrollCenter - centro);

    if (distancia < mejorDistancia) {
      mejorDistancia = distancia;
      paginaVisible = n;
    }
  }

  paginaActualPdf.value = paginaVisible;

  // Renderizar páginas cercanas (lazy loading)
  const buffer = 3;
  const desde = Math.max(1, paginaVisible - buffer);
  const hasta = Math.min(totalPaginasPdf.value, paginaVisible + buffer);
  
  for (let i = desde; i <= hasta; i++) {
    if (!paginasRenderizadas.value.has(i)) {
      renderizarPaginaPdf(i);
    }
  }
};


// ── Ir a una página con scroll suave ──
const irAPaginaScroll = async (numeroPagina) => {
  if (numeroPagina < 1 || numeroPagina > totalPaginasPdf.value) return;

  // Renderizar si no está lista
  if (!paginasRenderizadas.value.has(numeroPagina)) {
    await renderizarPaginaPdf(numeroPagina);
    await nextTick();
  }

  const wrapper = pdfPageRefs.value[numeroPagina];
  if (wrapper) {
    scrollUpdateLock.value = true;
    paginaActualPdf.value = numeroPagina;
    
    wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    
    setTimeout(() => {
      scrollUpdateLock.value = false;
    }, 500);
  }
};

// Ir a página por número ingresado
const irAPaginaInput = (event) => {
  const num = parseInt(event.target.value);
  if (num >= 1 && num <= totalPaginasPdf.value) {
    irAPaginaScroll(num);
  }
};



// Agregar emit para comunicarse con el padre (menuForm)
const emit = defineEmits(['cambiar-tab']);

// Función para manejar el cambio de tab
const handleCambiarTab = (tab) => {
  //console.log('treeViewExperimental - Cambiando a tab:', tab);     //Usarlo solo para ver los errores en el testeo de Software
  emit('cambiar-tab', tab);
};



const leftWidth = ref(500); // Ancho inicial del panel izquierdo en px
const isResizing = ref(false);


const startResize = (event) => {
  isResizing.value = true;
  event.preventDefault();

  const startX = event.clientX;
  const startWidth = leftWidth.value;

  const onMouseMove = (e) => {
    if (!isResizing.value) return;
    const delta = e.clientX - startX;
    const newWidth = startWidth + delta;
    // Limitar entre 200px y 80% del viewport
    leftWidth.value = Math.min(Math.max(newWidth, 200), window.innerWidth * 0.8);
  };


 const onMouseUp = () => {
    isResizing.value = false;
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  };

  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
  document.body.style.cursor = 'col-resize';
  document.body.style.userSelect = 'none';
};


// ============================================================
// VARIABLES PARA VERSIONES (Actualizar estas)
// ============================================================
const dialogVersiones = ref(false);
const versionesArchivo = ref([]);
const cargandoVersiones = ref(false);
const paginaActual = ref(1);
const itemsPorPagina = ref(5);

// Nueva versión
const dialogNuevaVersion = ref(false);
//const archivoNuevaVersion = ref(null);
const archivosNuevaVersion = ref([]);
//const comentarioVersion = ref('');
const subiendoVersion = ref(false);

const progresoSubida = ref(0);
const isDragging = ref(false);
const inputArchivoVersion = ref(null);


// Headers actualizados según la imagen
const headersVersiones = [
  { title: 'Usuario 2', key: 'usuario', sortable: true },
  { title: 'Fecha', key: 'fecha', sortable: true },
  { title: 'Peso', key: 'peso', sortable: true },
  { title: 'Version', key: 'version', sortable: true },
  { title: 'name_pc', key: 'ip', sortable: true }
];

// Computed para paginación
const totalPaginas = computed(() => {
  return Math.ceil(versionesArchivo.value.length / itemsPorPagina.value) || 1;
});

const rangoInicio = computed(() => {
  if (versionesArchivo.value.length === 0) return 0;
  return (paginaActual.value - 1) * itemsPorPagina.value + 1;
});

const rangoFin = computed(() => {
  const fin = paginaActual.value * itemsPorPagina.value;
  return Math.min(fin, versionesArchivo.value.length);
});


// Computed para tamaño total
const tamanoTotalArchivos = computed(() => {
  if (archivosNuevaVersion.value.length === 0) return '0 b';
  const total = archivosNuevaVersion.value.reduce((sum, archivo) => sum + archivo.size, 0);
  return formatearTamano(total);
});



// Formatear tamaño de archivo
const formatearTamano = (bytes) => {
  if (!bytes || bytes === 0) return '0 b';
  const k = 1024;
  const sizes = ['b', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};


// Obtener color según estado
const getEstadoColor = (estado) => {
  switch (estado) {
    case 'Pendiente': return 'grey';
    case 'Subiendo': return 'primary';
    case 'Completado': return 'success';
    case 'Error': return 'error';
    default: return 'grey';
  }
}

// Cerrar dialog
const cerrarDialogNuevaVersion = () => {
  if (subiendoVersion.value) {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ce501b',
      title: 'Subida en progreso',
      text: '¿Desea cancelar la subida?',
      showCancelButton: true,
      confirmButtonText: 'Sí, cancelar',
      cancelButtonText: 'No, continuar',
      confirmButtonColor: '#ce501b',
      cancelButtonColor: '#9B9B9B',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
          confirmButton: 'swal-btn-confirmar',
          cancelButton: 'swal-btn-cancelar'
        },
    }).then((result) => {
      if (result.isConfirmed) {
        subiendoVersion.value = false;
        dialogNuevaVersion.value = false;
      }
    });
  } else {
    dialogNuevaVersion.value = false;
  }
};


// Abrir selector de archivos
const abrirSelectorArchivos = () => {
  inputArchivoVersion.value.click();
};


// Manejar selección de archivo
const handleFileSelect = (event) => {
  const files = event.target.files;
  if (files && files.length > 0) {
    agregarArchivos(files);
  }
  // Limpiar input para permitir seleccionar el mismo archivo
  event.target.value = '';
};


// Manejar drop de archivos
const handleDrop = (event) => {
  isDragging.value = false;
  const files = event.dataTransfer.files;
  if (files && files.length > 0) {
    agregarArchivos(files);
  }
};

// Agregar archivos a la lista (MÚLTIPLES ARCHIVOS)
const agregarArchivos = (files) => {
  for (let i = 0; i < files.length; i++) {
    const archivo = files[i];
    
    // Verificar si el archivo ya existe en la lista (evitar duplicados)
    const yaExiste = archivosNuevaVersion.value.some(
      a => a.name === archivo.name && a.size === archivo.size
    );
    
    if (!yaExiste) {
      archivosNuevaVersion.value.push({
        file: archivo,
        name: archivo.name,
        size: archivo.size,
        estado: 'Pendiente'
      });
    }
  }
};


// Versiones de la página actual
const versionesPaginadas = computed(() => {
  const inicio = (paginaActual.value - 1) * itemsPorPagina.value;
  const fin = inicio + itemsPorPagina.value;
  return versionesArchivo.value.slice(inicio, fin);
});

// Páginas visibles para la paginación (máximo 5 números)
const paginasVisibles = computed(() => {
  const total = totalPaginas.value;
  const actual = paginaActual.value;
  const paginas = [];
  
  if (total <= 5) {
    // Si hay 5 o menos páginas, mostrar todas
    for (let i = 1; i <= total; i++) {
      paginas.push(i);
    }
  } else {
    // Mostrar 5 páginas centradas en la actual
    let inicio = Math.max(1, actual - 2);
    let fin = Math.min(total, inicio + 4);
    
    // Ajustar si estamos cerca del final
    if (fin - inicio < 4) {
      inicio = Math.max(1, fin - 4);
    }
    
    for (let i = inicio; i <= fin; i++) {
      paginas.push(i);
    }
  }
  
  return paginas;
});




// ============================================================
// FUNCIONES PARA VERSIONES
// ============================================================

// Formatear fecha para versiones
const formatearFechaVersion = (fecha) => {
  if (!fecha) return '';
  const date = new Date(fecha);
  return date.toLocaleDateString('es-PE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Formatear peso del archivo

const formatearPeso = (bytes) => {
  if (!bytes || bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
  


// Obtener extensión del archivo actual
/*
const obtenerExtensionArchivo = () => {
  if (!archivoContexto.value?.name) return '*';
  const ext = archivoContexto.value.name.split('.').pop();
  return `.${ext}`;
};
*/
// Ver versiones (actualizada)
const verVersiones = async () => {
  showMenuArchivo.value = false;
  
  cargandoVersiones.value = true;
  dialogVersiones.value = true;
  versionesArchivo.value = [];
  paginaActual.value = 1;

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');

    const response = await axios.get(
      `/api/Version/listar/${archivoContexto.value.tocId}?idUsuarioSesion=${idUsuarioSesion}`
    );

    if (response.data.success) {
      versionesArchivo.value = response.data.data;
    }

  } /* catch (error) {  //Usarlo solo para ver los errores en el testeo de Software
    console.error('Error al cargar versiones:', error);
    // Sin datos de ejemplo - mostrar tabla vacía
    versionesArchivo.value = [];

  } */ finally {
    cargandoVersiones.value = false;
  }
};

// Abrir dialog para nueva versión
const nuevaVersion = () => {
  archivosNuevaVersion.value = [];
  progresoSubida.value = 0;
  subiendoVersion.value = false;
  isDragging.value = false;
  dialogNuevaVersion.value = true;
};



// Subir nueva versión (MÚLTIPLES ARCHIVOS)


const subirNuevaVersion = async () => {
  if (archivosNuevaVersion.value.length === 0) return;

  subiendoVersion.value = true;
  progresoSubida.value = 0;

  const totalArchivos = archivosNuevaVersion.value.length;
  let archivosSubidos = 0;
  let errores = [];

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    const tocIdDocumento = archivoContexto.value.tocId;

    // Procesar cada archivo
    for (let i = 0; i < archivosNuevaVersion.value.length; i++) {
      const archivo = archivosNuevaVersion.value[i];
      archivo.estado = 'Subiendo';

      try {
        const formData = new FormData();
        formData.append('file', archivo.file);

        // ✅ ENVIAR SIN CHUNKS - solo chunk=0 y chunks=1
        const url = `/api/Upload/upload-version?tocIdDocumento=${tocIdDocumento}&chunk=0&chunks=1&idUsuarioSesion=${idUsuarioSesion}`;

        const response = await axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            // Calcular progreso
            const archivoProgress = (progressEvent.loaded / progressEvent.total) * 100;
            const progresoArchivosCompletados = (archivosSubidos / totalArchivos) * 100;
            const progresoArchivoActual = (archivoProgress / totalArchivos);
            
            progresoSubida.value = Math.min(
              Math.round(progresoArchivosCompletados + progresoArchivoActual),
              99
            );
          }
        });

        if (!response.data.success) {
          throw new Error(response.data.mensaje || 'Error al subir archivo');
        }

        // Archivo completado
        archivo.estado = 'Completado';
        archivosSubidos++;

      } catch (error) {
        //console.error(`Error al subir ${archivo.name}:`, error);  //Usarlo solo para ver los errores en el testeo de Software
        archivo.estado = 'Error';
        errores.push({
          nombre: archivo.name,
          error: error.response?.data?.mensaje || error.message
        });
      }
    }

    // Actualizar progreso final
    progresoSubida.value = 100;

    // Mostrar resultado
    if (errores.length === 0) {
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Éxito!',
        html: `Se subieron <strong>${archivosSubidos}</strong> archivo(s) correctamente`,
        timer: 2500,
        confirmButtonColor: '#ce501b',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
          confirmButton: 'swal-btn-confirmar'
        },
        showConfirmButton: false
      });

      dialogNuevaVersion.value = false;

      // Recargar lista de versiones
      await verVersiones();

    } else if (archivosSubidos > 0) {
      await Swal.fire({
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Subida parcial',
        confirmButtonColor: '#ce501b',
        html: `
          <p>Se subieron <strong>${archivosSubidos}</strong> de <strong>${totalArchivos}</strong> archivo(s).</p>
          <p style="color: #ce501b; margin-top: 10px;">${errores.length} archivo(s) con error:</p>
          <ul style="text-align: left; max-height: 150px; overflow-y: auto; font-size: 13px;">
            ${errores.map(e => `<li>${e.nombre}: ${e.error}</li>`).join('')}
          </ul>
        `,
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
          confirmButton: 'swal-btn-confirmar'
        },
        confirmButtonText: 'OK'
      });

      await verVersiones();

    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
        html: `
          <p>No se pudo subir ningún archivo.</p>
          <ul style="text-align: left; max-height: 150px; overflow-y: auto; font-size: 13px;">
            ${errores.map(e => `<li>${e.nombre}: ${e.error}</li>`).join('')}
          </ul>
        `
      });
    }

  } catch (error) {
    //console.error('Error general al subir versiones:', error);    //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.message || 'No se pudieron subir los archivos',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
  } finally {
    subiendoVersion.value = false;
  }
};




// ===========================================================
// VARIABLES PARA MENÚ CONTEXTUAL DE ARCHIVOS
// ============================================================
const showMenuArchivo = ref(false);
const menuArchivoX = ref(0);
const menuArchivoY = ref(0);
const archivoContexto = ref(null);
const archivoSeleccionado = ref(null);

// Variables para Indexación de archivo
const dialogIndexarArchivo = ref(false);
const estructuraPlantillaArchivo = ref([]);
const valoresIndexacionArchivo = ref({});
const cargandoEstructuraArchivo = ref(false);
const guardandoIndexacion = ref(false);
const esEdicionIndexacion = ref(false);  

// Variables para Compartir
const dialogCompartir = ref(false);
const listaUsuariosCompartir = ref([]);
const usuariosCompartir = ref([]);
const permisoCompartir = ref(null);
const tiposPermisoCompartir = ref([
  { id: 1, nombre: 'Solo lectura' },
  { id: 2, nombre: 'Lectura y descarga' },
  { id: 3, nombre: 'Control total' }
]);
const enlaceCompartir = ref('');
const generandoEnlace = ref(false);

// Variables para OCR
const dialogOCR = ref(false);
const procesandoOCR = ref(false);
const progresoOCR = ref(0);
const resultadoOCR = ref('');


const formatearValorDinamico = (valor, dataType) => {
  if (!valor || valor === '' || valor === null) return '';
  
  if (dataType && dataType.toLowerCase().includes('date')) {
    const fecha = new Date(valor);
    if (!isNaN(fecha.getTime())) {
      return fecha.toLocaleDateString('es-PE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  }
  
  return valor;
};

// ============================================================
// FUNCIONES PARA MENÚ CONTEXTUAL
// ============================================================

const abrirMenuArchivo = async (event, archivo) => {
  event.preventDefault();
  archivoContexto.value = archivo;
  menuArchivoX.value = event.clientX;
  menuArchivoY.value = event.clientY;

  // Verificar si tiene indexación
  let templateId = archivo.templateId;
  if (!templateId || templateId === 0) {
    templateId = selectedFolderTemplateId.value;
  }

  if (templateId && templateId > 0) {
    try {
      const response = await axios.get(
        `/api/Indexacion/buscar-indexacion/${archivo.tocId}/${templateId}`
      );
        // ✅ Definir la variable ANTES de usarla
      const tieneIndexacion = response.data.data && response.data.data.length > 0;

      textoMenuIndexacion.value = (response.data.data && response.data.data.length > 0) 
        ? 'Editar Indexación' 
        : 'Indexación';
        esEdicionIndexacion.value = tieneIndexacion;   // ← AGREGAR ESTA LÍNEA
    } catch (error) {
      textoMenuIndexacion.value = 'Indexación';
      esEdicionIndexacion.value = false;
    }
  } else {
    textoMenuIndexacion.value = 'Indexación';
    esEdicionIndexacion.value = false;   // ← AGREGAR ESTA LÍNEA
  }

  showMenuArchivo.value = true;
};


// Seleccionar archivo (click normal)
const seleccionarArchivo = (archivo) => {
  archivoSeleccionado.value = archivo;
  //console.log('Archivo seleccionado:', archivo);    //Usarlo solo para ver los errores en el testeo de Software
};

// Obtener icono según extensión del archivo
const getFileIcon = (fileName) => {
  if (!fileName) return 'mdi-file-document-outline';
  const ext = fileName.split('.').pop().toLowerCase();
  
  const iconMap = {
    'pdf': 'mdi-file-pdf-box',
    'doc': 'mdi-file-word',
    'docx': 'mdi-file-word',
    'xls': 'mdi-file-excel',
    'xlsx': 'mdi-file-excel',
    'ppt': 'mdi-file-powerpoint',
    'pptx': 'mdi-file-powerpoint',
    'jpg': 'mdi-file-image',
    'jpeg': 'mdi-file-image',
    'png': 'mdi-file-image',
    'gif': 'mdi-file-image',
    'bmp': 'mdi-file-image',
    'tiff': 'mdi-file-image',
    'tif': 'mdi-file-image',
    'txt': 'mdi-file-document-outline',
    'zip': 'mdi-folder-zip',
    'rar': 'mdi-folder-zip',
    'mp4': 'mdi-file-video',
    'avi': 'mdi-file-video',
    'mp3': 'mdi-file-music',
    'xml': 'mdi-file-code',
    'json': 'mdi-file-code',
    'html': 'mdi-file-code'
  };
  
  return iconMap[ext] || 'mdi-file-document-outline';
};

// Obtener color del icono según extensión
const getFileIconColor = (fileName) => {
  if (!fileName) return 'grey';
  const ext = fileName.split('.').pop().toLowerCase();
  
  const colorMap = {
    'pdf': 'red',
    'doc': 'blue',
    'docx': 'blue',
    'xls': 'green',
    'xlsx': 'green',
    'ppt': 'orange',
    'pptx': 'orange',
    'jpg': 'purple',
    'jpeg': 'purple',
    'png': 'purple',
    'gif': 'purple',
    'tiff': 'purple',
    'tif': 'purple'
  };
  
  return colorMap[ext] || 'grey';
};

// Helpers para campos
const esCampoFecha = (tipo) => {
  if (!tipo) return false;
  const tipoLower = tipo.toLowerCase();
  return tipoLower.includes('date') || tipoLower.includes('datetime');
};

const getOpcionesCombo = (valores) => {
  if (!valores) return [];
  return valores.split(',').map(v => v.trim());
};


// ============================================================
// FUNCIÓN: INDEXACIÓN DE ARCHIVO
// ============================================================

const cargarValoresIndexacionExistentes = async (tocId, templateId) => {
  //try {   //Usarlo solo para ver los errores en el testeo de Software
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    
    const response = await axios.get(
      `/api/Indexacion/obtener/${tocId}/${templateId}?idUsuarioSesion=${idUsuarioSesion}`
    );
    
    if (response.data.success && response.data.data) {
      const datosExistentes = response.data.data;
      for (const campo of estructuraPlantillaArchivo.value) {
        if (datosExistentes[campo.column_name] !== undefined && datosExistentes[campo.column_name] !== null) {
          let valor = datosExistentes[campo.column_name];
          
          // Si es campo fecha, convertir "2026-02-25T00:00:00" → "2026-02-25"
          if (esCampoFecha(campo.data_type) && valor) {
            const fecha = new Date(valor);
            if (!isNaN(fecha.getTime())) {
              const year = fecha.getFullYear();
              const month = String(fecha.getMonth() + 1).padStart(2, '0');
              const day = String(fecha.getDate()).padStart(2, '0');
              valor = `${year}-${month}-${day}`;
            }
          }
          
          valoresIndexacionArchivo.value[campo.column_name] = valor;
        }
      }
    }
  /* } catch (error) {    //Usarlo solo para ver los errores en el testeo de Software
    console.log('No hay indexación previa para este archivo');
  } */
};


// Guardar indexación del archivo

const guardarIndexacionArchivo = async () => {
  try {
     let response;
    // Validar que haya al menos un campo con valor
    const tieneValores = Object.values(valoresIndexacionArchivo.value).some(v => v !== '' && v !== null);
    
    if (!tieneValores) {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Datos incompletos',
        text: 'Debe completar al menos un campo',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      });
      return;
    }

    guardandoIndexacion.value = true;

    let templateId = archivoContexto.value.templateId || selectedFolderTemplateId.value;
    const idUsuarioSesion = localStorage.getItem('idUsuario');

    // Construir campos
    const campos = [];
    for (const campo of estructuraPlantillaArchivo.value) {
      const valor = valoresIndexacionArchivo.value[campo.column_name];
      
      if (valor !== '' && valor !== null && valor !== undefined) {
        let tipoDato = 'varchar';
        let valorFinal = valor.toString();

        if (campo.data_type) {
          const tipoLower = campo.data_type.toLowerCase();
          if (tipoLower.includes('date')) {
            tipoDato = 'datetime';
          } else if (tipoLower.includes('int') || tipoLower.includes('numeric')) {
            tipoDato = 'int';
          }
        }

        campos.push({
          nombreCampo: campo.column_name,
          valor: valorFinal,
          tipoDato: tipoDato
        });
      }
    }


      if (esEdicionIndexacion.value) {
      // ✅ MODO EDICIÓN: usar PUT a /actualizar
      response = await axios.put(
        `/api/Indexacion/actualizar?idUsuarioSesion=${idUsuarioSesion}`,
        {
          plantillaId: parseInt(templateId),
          tocId: archivoContexto.value.tocId,
          campos: campos
        }
      );
    } else {

     response = await axios.post(
      `/api/Indexacion/insertar?idUsuarioSesion=${idUsuarioSesion}`,
      {
        plantillaId: parseInt(templateId),
        tocId: archivoContexto.value.tocId,
        campos: campos
      }
    );

    }


    guardandoIndexacion.value = false;

    if (response.data.success) {
      dialogIndexarArchivo.value = false;
      
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Éxito!',
        text: esEdicionIndexacion.value 
          ? 'Indexación actualizada correctamente'   
          : 'Archivo indexado correctamente',         
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });

      // Recargar archivos
      if (selectedFolder.value) {
        await loadFilesForFolder(selectedFolder.value.tocId);
      }
    } else {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: response.data.mensaje || 'No se pudo guardar la indexación',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }

      });
    }

  } catch (error) {
    guardandoIndexacion.value = false;
    //console.error('Error al guardar indexación:', error);     //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'Hubo un problema al guardar',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
  }
};

const desindexarArchivo = async () => {
  showMenuArchivo.value = false;

  let templateId = archivoContexto.value.templateId;
  if (!templateId || templateId === 0) {
    templateId = selectedFolderTemplateId.value;
  }

  if (!templateId || templateId === 0) {
    Swal.fire({
      icon: 'warning', iconColor: '#ce501b', title: 'Sin plantilla',
      text: 'No se pudo determinar la plantilla de este archivo',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
    return;
  }

  const confirmacion = await Swal.fire({
    title: '¿Está seguro?',
    html: `¿Desea <strong>desindexar</strong> el archivo:<br><strong>${archivoContexto.value.name}</strong>?`,
    icon: 'warning',
    iconColor: '#ce501b',
    showCancelButton: true,
    confirmButtonText: 'Sí, desindexar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    focusConfirm: true,
    allowEnterKey: true,
    keydownListenerCapture: true,
    customClass: {
      title: 'swal-title-custom',
      confirmButton: 'swal-btn-confirmar',
      cancelButton: 'swal-btn-cancelar',
      container: 'swal-sobre-modal'
    },
    didOpen: () => { Swal.getConfirmButton()?.focus() }
  });

  if (!confirmacion.isConfirmed) return;

  const idUsuarioSesion = localStorage.getItem('idUsuario');

  Swal.fire({
    title: 'Desindexando...',
    allowOutsideClick: false,
    customClass: { title: 'swal-title-custom', loader: 'swal-loader-custom', container: 'swal-sobre-modal' },
    didOpen: () => Swal.showLoading()
  });

  try {
    const res = await axios.put(
      `/api/Desindexacion/desindexar?idUsuarioSesion=${idUsuarioSesion}`,
      {
        tocId: archivoContexto.value.tocId,
        idplantilla: parseInt(templateId)
      }
    );

    Swal.close();

    const ok = res.data?.succes ?? res.data?.success ?? true;

    if (ok) {
      await Swal.fire({
        icon: 'success', iconColor: '#ce501b', title: '¡Desindexado!',
        text: 'El archivo fue desindexado correctamente',
        timer: 2000, showConfirmButton: false,
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });

      // Recargar archivos de la carpeta actual (igual que hace guardarIndexacionArchivo)
      if (selectedFolder.value) {
        await loadFilesForFolder(selectedFolder.value.tocId);
      }
    } else {
      Swal.fire({
        icon: 'error', iconColor: '#ce501b', title: 'Error',
        text: res.data?.mensaje || 'No se pudo desindexar el archivo',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
    }
  } catch (err) {
    Swal.close();
    Swal.fire({
      icon: 'error', iconColor: '#ce501b', title: 'Error',
      text: err.response?.data?.mensaje || 'Hubo un problema al desindexar el archivo',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
  }
};

const indexarArchivo = async () => {
  showMenuArchivo.value = false;
  modoVisualizacion.value = false; // ← agregar esta línea
  try {
    let templateId = archivoContexto.value.templateId;
    if (!templateId || templateId === 0) {
      templateId = selectedFolderTemplateId.value;
    }

    if (!templateId || templateId === 0) {
      Swal.fire({ 
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Sin plantilla', 
        text: 'Este archivo no tiene una plantilla asignada',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      });
      return;
    }

    // ── 1. Abrir el dialog de inmediato con loaders activos
    cargandoEstructuraArchivo.value = true;
    cargandoPdfVisor.value = true;
    errorPdfVisor.value   = '';
    urlPdfVisor.value     = '';

    // ✅ Resetear modo multi-página
    modoPaginasMultiples.value = false
    listaPaginas.value         = []
    urlPaginaMultiple.value    = ''
    paginaMultipleActual.value = 1

    dialogIndexarArchivo.value = true;
    zoomArchivoLevel.value = 1
    // ── 2. Cargar estructura de la plantilla y PDF en paralelo
    const [responseEstructura] = await Promise.all([
      axios.get(`/api/Plantillas/estructura/${templateId}`),
      cargarPdfVisor(archivoContexto.value.tocId, templateId)
    ]);
    await cargarAnotaciones(archivoContexto.value.tocId);
    cargandoEstructuraArchivo.value = false;

    if (responseEstructura.data.success && responseEstructura.data.data.length > 0) {
      estructuraPlantillaArchivo.value = responseEstructura.data.data;

      // Inicializar valores vacíos
      valoresIndexacionArchivo.value = {};
      estructuraPlantillaArchivo.value.forEach(campo => {
        valoresIndexacionArchivo.value[campo.column_name] = '';
      });

      // Cargar valores existentes si ya está indexado
      await cargarValoresIndexacionExistentes(archivoContexto.value.tocId, templateId);
    } else {
      dialogIndexarArchivo.value = false;
      Swal.fire({ 
        icon: 'info',
        iconColor: '#ce501b',
        title: 'Sin campos', 
        text: 'Esta plantilla no tiene campos disponibles',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }

  } catch (error) {
    cargandoEstructuraArchivo.value = false;
    cargandoPdfVisor.value = false;
    //console.error('Error al cargar estructura:', error);    //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      title: 'Error',
      iconColor: '#ce501b',
      text: error.response?.data?.mensaje || 'No se pudo cargar la estructura de indexación',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
    });
  }
};


// ── Multi-página (nuevo SP) ──
const modoPaginasMultiples = ref(false)
const listaPaginas = ref([])           // PaginaDto[] del API
const paginaMultipleActual = ref(1)    
const urlPaginaMultiple = ref('')      // blob URL de la página actual
const cargandoPaginaMultiple = ref(false)
const esTiffPaginaMultiple = ref(false)
const esImagenPaginaMultiple = ref(false)
const errorPaginaMultiple = ref('')    // ✅ NUEVO




// ── Cargar una página del modo multi-página ──
const cargarPaginaMultiple = async (nroPag) => {
  if (!listaPaginas.value.length) return

  const paginaInfo = listaPaginas.value.find(p => p.nroPag === nroPag)
  if (!paginaInfo) return

  zoomMultiLevel.value = 1  // ✅ resetear zoom al cambiar página para que sea 50%

  cargandoPaginaMultiple.value = true
  esTiffPaginaMultiple.value = false
  esImagenPaginaMultiple.value = false
  errorPaginaMultiple.value = ''        // ✅ limpiar error previo

  if (urlPaginaMultiple.value && urlPaginaMultiple.value.startsWith('blob:')) {
    URL.revokeObjectURL(urlPaginaMultiple.value)
  }
  urlPaginaMultiple.value = ''

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    const tocId = archivoContexto.value.tocId
    const plantillaId = archivoContexto.value.templateId || selectedFolderTemplateId.value

    const response = await axios.get(
      `/api/Indexacion/ver-pagina/${tocId}/${plantillaId}/${nroPag}?idUsuarioSesion=${idUsuarioSesion}`,
      { responseType: 'arraybuffer' }
    )

    const contentType = response.headers['content-type'] || 'image/tiff'
    const esTiff = contentType === 'image/tiff' || contentType === 'image/tif'

    if (esTiff) {
      const ifds = UTIF.decode(response.data)
      UTIF.decodeImage(response.data, ifds[0])
      const rgba = UTIF.toRGBA8(ifds[0])
      const w = ifds[0].width
      const h = ifds[0].height
      const canvas = document.createElement('canvas')
      canvas.width = w; canvas.height = h
      const ctx = canvas.getContext('2d')
      const imageData = ctx.createImageData(w, h)
      imageData.data.set(new Uint8Array(rgba))
      ctx.putImageData(imageData, 0, 0)
      urlPaginaMultiple.value = canvas.toDataURL('image/png')
      esTiffPaginaMultiple.value = true
      esImagenPaginaMultiple.value = true
    } else {
      esImagenPaginaMultiple.value = contentType.startsWith('image/')
      const blob = new Blob([response.data], { type: contentType })
      urlPaginaMultiple.value = URL.createObjectURL(blob)
      if (!esImagenPaginaMultiple.value) {
        await nextTick()
        await renderizarPdfJsMultiple(urlPaginaMultiple.value)
      }
    }

    paginaMultipleActual.value = nroPag

  } catch (error) {
    // ✅ Mostrar error específico dentro del área multi-página
    const status = error.response?.status
    errorPaginaMultiple.value = status === 404
      ? `Página ${nroPag} no encontrada en el servidor`
      : `Error al cargar página ${nroPag} (${status || 'sin conexión'})`
  } finally {
    cargandoPaginaMultiple.value = false
  }
}


// ── Renderizar PDF.js para una sola página en modo multi ──
const pdfMultipleDocumento = shallowRef(null)
const totalPaginasMultiplePdf = ref(0)
const paginaActualMultiplePdf = ref(1)

const renderizarPdfJsMultiple = async (url) => {
  const loadingTask = pdfjsLib.getDocument(url)
  const pdf = await loadingTask.promise
  pdfMultipleDocumento.value = pdf
  totalPaginasMultiplePdf.value = pdf.numPages
  paginaActualMultiplePdf.value = 1

  await nextTick()
  await nextTick()

  const page = await pdf.getPage(1)
  const canvas = document.getElementById('pdf-canvas-multiple')
  if (!canvas) return

  const viewport = page.getViewport({ scale: 1.5 })
  canvas.width = viewport.width
  canvas.height = viewport.height
  await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise
}



const cargarPdfVisor = async (tocId, plantillaId) => {
  archivoNoVisualizable.value = false

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    const token = localStorage.getItem('token')
    const nombreArchivo = archivoContexto.value?.name || ''
    const ext = nombreArchivo.split('.').pop().toLowerCase()

    if (ext === 'doc' || ext === 'docx') {
      cargandoPdfVisor.value = false
      modoPaginasMultiples.value = false
      esImagenVisor.value = false
      esVideoVisor.value = false
      esAudioVisor.value = false
      urlPdfVisor.value = ''
      errorPdfVisor.value = ''
      archivoNoVisualizable.value = true
      return
    }

    // ══════════════════════════════════════════════════════
    // 1. ZIP / RAR → sin visor
    // ══════════════════════════════════════════════════════
    if (ext === 'zip' || ext === 'rar') {
      cargandoPdfVisor.value = false
      modoPaginasMultiples.value = false
      esImagenVisor.value = false
      esVideoVisor.value = false
      esAudioVisor.value = false
      urlPdfVisor.value = ''
      errorPdfVisor.value = 'El visor no está disponible para archivos ZIP o RAR'
      return
    }

    // ══════════════════════════════════════════════════════
    // 2. VIDEO → STREAMING PROGRESIVO (NO descargar blob)
    // ══════════════════════════════════════════════════════
    if (extensionesVideo.includes(ext)) {
      modoPaginasMultiples.value = false
      esVideoVisor.value = true
      esImagenVisor.value = false
      esAudioVisor.value = false
      mimeVisor.value = `video/${ext === 'mkv' ? 'x-matroska' : ext === 'm4v' ? 'mp4' : ext === 'mov' ? 'quicktime' : ext}`

      // Liberar blob anterior si existía
      if (urlPdfVisor.value && urlPdfVisor.value.startsWith('blob:')) {
        URL.revokeObjectURL(urlPdfVisor.value)
      }

      // ✅ URL DIRECTA con token → el <video> hace Range Requests automáticos
      urlPdfVisor.value = buildApiUrl(
        `/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}?token=${encodeURIComponent(token)}`
      )
      cargandoPdfVisor.value = false
      return   // ← MUY IMPORTANTE: salir aquí, no descargar nada
    }

    // ══════════════════════════════════════════════════════
    // 3. AUDIO → STREAMING PROGRESIVO (NO descargar blob)
    // ══════════════════════════════════════════════════════
    if (extensionesAudioVisor.includes(ext)) {
      modoPaginasMultiples.value = false
      esAudioVisor.value = true
      esImagenVisor.value = false
      esVideoVisor.value = false
      mimeVisor.value = `audio/${ext === 'm4a' ? 'mp4' : ext === 'flac' ? 'flac' : ext}`

      if (urlPdfVisor.value && urlPdfVisor.value.startsWith('blob:')) {
        URL.revokeObjectURL(urlPdfVisor.value)
      }

      // ✅ URL DIRECTA con token
      urlPdfVisor.value = buildApiUrl(
        `/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}?token=${encodeURIComponent(token)}`
      )
      cargandoPdfVisor.value = false
      return   // ← salir aquí
    }

    // ══════════════════════════════════════════════════════
    // 4. CONSULTAR PÁGINAS (solo para PDF/imagen)
    // ══════════════════════════════════════════════════════
    let totalPags = 0
    let paginas = []

    try {
      const resPaginas = await axios.get(
        `/api/Indexacion/paginas/${tocId}/${plantillaId}?idUsuarioSesion=${idUsuarioSesion}&nroDocumento=${encodeURIComponent(nombreArchivo)}`
      )
      if (resPaginas.data.success) {
        totalPags = resPaginas.data.totalPaginas
        paginas = resPaginas.data.data
      }
    } catch (e) {
      totalPags = 0
    }

    // ══════════════════════════════════════════════════════
    // 5. MODO MULTI-PÁGINA (imágenes paginadas)
    // ══════════════════════════════════════════════════════
    if (totalPags > 1) {
      const tienePdfs = paginas.some(p => p.path.toLowerCase().endsWith('.pdf'))

      if (tienePdfs) {
        cargandoPdfVisor.value = false
        errorPdfVisor.value = 'No es posible visualizar múltiples documentos PDF. Solo se permite indexar un único archivo PDF por expediente.'
        return
      }

      modoPaginasMultiples.value = true
      listaPaginas.value = paginas
      paginaMultipleActual.value = 1
      urlPaginaMultiple.value = ''

      await cargarPaginaMultiple(1)
      cargandoPdfVisor.value = false
      return
    }

    // ══════════════════════════════════════════════════════
    // 6. PDF / IMAGEN / TIFF → flujo original con blob
    // ══════════════════════════════════════════════════════
    modoPaginasMultiples.value = false
    listaPaginas.value = []

    const response = await axios.get(
      `/api/Indexacion/ver-documento/${tocId}/${idUsuarioSesion}/${plantillaId}`,
      { responseType: 'blob' }
    )

    const contentType = response.headers['content-type'] || 'application/pdf'
    const esTiff = contentType === 'image/tiff' || contentType === 'image/tif' || ext === 'tif' || ext === 'tiff'

    esImagenVisor.value = false
    esTiffVisor.value = false
    esVideoVisor.value = false
    esAudioVisor.value = false
    mimeVisor.value = ''

    if (urlPdfVisor.value && urlPdfVisor.value.startsWith('blob:')) {
      URL.revokeObjectURL(urlPdfVisor.value)
    }

    if (esTiff) {
      const buffer = await response.data.arrayBuffer()
      const ifds = UTIF.decode(buffer)
      UTIF.decodeImage(buffer, ifds[0])
      const rgba = UTIF.toRGBA8(ifds[0])
      const w = ifds[0].width
      const h = ifds[0].height
      const canvas = document.createElement('canvas')
      canvas.width = w; canvas.height = h
      const ctx = canvas.getContext('2d')
      const imageData = ctx.createImageData(w, h)
      imageData.data.set(new Uint8Array(rgba))
      ctx.putImageData(imageData, 0, 0)
      urlPdfVisor.value = canvas.toDataURL('image/png')
      esImagenVisor.value = true
      cargandoPdfVisor.value = false

    } else {
      esImagenVisor.value = contentType.startsWith('image/')
      const blob = new Blob([response.data], { type: contentType })
      urlPdfVisor.value = URL.createObjectURL(blob)
      cargandoPdfVisor.value = false
      await nextTick(); await nextTick()
      if (!esImagenVisor.value) await renderizarPdfJs(urlPdfVisor.value)
    }

  } catch (error) {
    cargandoPdfVisor.value = false
    if (error.response?.status === 404) errorPdfVisor.value = 'Archivo no encontrado en el servidor'
    else if (error.response?.status === 400) errorPdfVisor.value = 'Parámetros inválidos'
    else errorPdfVisor.value = 'No se pudo cargar el documento'
  }
}

const descargarDocumentoWord = () => {
  const archivo = archivoContexto.value
  if (!archivo) return

  const idUsuarioSesion = localStorage.getItem('idUsuario')
  const plantillaId = archivo.templateId || selectedFolderTemplateId.value

  procesarDescargaArchivo({
    url: `/api/Indexacion/ver-documento/${archivo.tocId}/${idUsuarioSesion}/${plantillaId}`,
    nombre: archivo.name
  })
}



// ============================================================
// FUNCIÓN: COMPARTIR ARCHIVO
// ============================================================


// Generar enlace de descarga
const generarEnlaceCompartir = async () => {
  generandoEnlace.value = true;
  
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    
    const response = await axios.post(
      `/api/File/generar-enlace?idUsuarioSesion=${idUsuarioSesion}`,
      {
        tocId: archivoContexto.value.tocId,
        expiracion: 7 // días
      }
    );

    if (response.data.success) {
      enlaceCompartir.value = response.data.enlace;
    } else {
      throw new Error(response.data.mensaje);
    }
  
  } /* catch (error) {    //Usarlo solo para ver los errores en el testeo de Software
    console.error('Error al generar enlace:', error);
    // Generar enlace simulado para demostración
    enlaceCompartir.value = buildApiUrl(
      `/api/File/download/${archivoContexto.value.tocId}?token=demo123`
    )
  } */
  finally {
    generandoEnlace.value = false;
  }
};

// Copiar enlace al portapapeles
const copiarEnlace = async () => {
  //try { //Usarlo solo para ver los errores en el testeo de Software
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(enlaceCompartir.value);
  } else {
      const textarea = document.createElement('textarea');
      textarea.value = enlaceCompartir.value;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
  }
    Swal.fire({
      icon: 'success',
      iconColor: '#ce501b',
      title: 'Copiado',
      text: 'Enlace copiado al portapapeles',
      timer: 1500,
      showConfirmButton: false,
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
  /*  //Usarlo solo para ver los errores en el testeo de Software
  } catch (error) {
    //console.error('Error al copiar:', error);    //Usarlo solo para ver los errores en el testeo de Software
  } */
};

// Confirmar compartir
const confirmarCompartir = async () => {
  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');

    Swal.fire({
      title: 'Compartiendo archivo...',
      allowOutsideClick: false,
      customClass: {
         title: 'swal-title-custom',
         loader: 'swal-loader-custom'
      },
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const response = await axios.post(
      `/api/File/compartir?idUsuarioSesion=${idUsuarioSesion}`,
      {
        tocId: archivoContexto.value.tocId,
        usuarios: usuariosCompartir.value,
        tipoPermiso: permisoCompartir.value
      }
    );

    if (response.data.success) {
      dialogCompartir.value = false;
      
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Compartido!',
        text: 'El archivo se ha compartido correctamente',
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      });
    } else {
      throw new Error(response.data.mensaje);
    }

  } catch (error) {
    //console.error('Error al compartir:', error);   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || 'No se pudo compartir el archivo',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
  }
};


// ============================================================
// FUNCIÓN: GENERAR OCR
// ============================================================
const generarOCR = () => {
  showMenuArchivo.value = false;
  
  // Validar que sea una imagen o PDF
  const ext = archivoContexto.value.name.split('.').pop().toLowerCase();
  const formatosPermitidos = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'tif', 'pdf'];
  
  if (!formatosPermitidos.includes(ext)) {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ce501b',
      title: 'Formato no soportado',
      text: 'El OCR solo funciona con imágenes (JPG, PNG, TIFF) o PDF',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
    return;
  }

  // Resetear valores
  resultadoOCR.value = '';
  progresoOCR.value = 0;
  procesandoOCR.value = false;

  dialogOCR.value = true;
};

// Ejecutar OCR
const ejecutarOCR = async () => {
  procesandoOCR.value = true;
  progresoOCR.value = 0;
  resultadoOCR.value = '';

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');

    // Simular progreso
    const intervalo = setInterval(() => {
      if (progresoOCR.value < 90) {
        progresoOCR.value += 10;
      }
    }, 500);

    // Obtener plantillaId del archivo o carpeta
    let plantillaId = archivoContexto.value.templateId;
    if (!plantillaId || plantillaId === 0) {
      plantillaId = selectedFolderTemplateId.value;
    }

    const response = await axios.post(
      `/api/Doc/procesar?idUsuarioSesion=${idUsuarioSesion}`,
      {
        tocId: archivoContexto.value.tocId,
        plantillaId: plantillaId
      }
    );

    clearInterval(intervalo);
    progresoOCR.value = 100;

    if (response.data.success) {
      resultadoOCR.value = response.data.texto;
      
      await Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡OCR completado!',
        html: `
          <p>Texto extraído correctamente</p>
          <p><small>Páginas procesadas: ${response.data.paginasProcesadas}</small></p>
          ${response.data.paginasConError > 0 ? `<p><small style="color: #ce501b;">Con errores: ${response.data.paginasConError}</small></p>` : ''}
        `,
        timer: 3000,
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
        showConfirmButton: false
      });
    } else {
      throw new Error(response.data.mensaje);
    }

  } catch (error) {
    //console.error('Error en OCR:', error);  //Usarlo solo para ver los errores en el testeo de Software
    progresoOCR.value = 100;
    
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error en OCR',
      text: error.response?.data?.mensaje || error.message || 'No se pudo procesar el OCR',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
    });
    
  } finally {
    procesandoOCR.value = false;
  }
};

const textareaOCR = ref(null);

// Copiar texto OCR
const copiarTextoOCR = () => {
  const texto = resultadoOCR.value;

  if (!texto) {
    Swal.fire({
      icon: 'warning', iconColor: '#ce501b',
      title: 'Sin texto', text: 'No hay texto para copiar',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
    return;
  }

  // ✅ Obtener el <textarea> nativo dentro del v-textarea de Vuetify
  const nativeTextarea = textareaOCR.value?.$el?.querySelector('textarea');

  if (nativeTextarea) {
    nativeTextarea.select();
    nativeTextarea.setSelectionRange(0, 99999);
    const copiado = document.execCommand('copy');

    if (copiado) {
      Swal.fire({
        icon: 'success', iconColor: '#ce501b',
        title: '¡Copiado!', text: 'Texto copiado al portapapeles',
        timer: 1500, showConfirmButton: false,
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
      return;
    }
  }

  // Fallback: mostrar instrucción manual
  Swal.fire({
    icon: 'info', iconColor: '#ce501b',
    title: 'Copia manual',
    text: 'Haz clic en el texto, presiona Ctrl+A y luego Ctrl+C',
    customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
  });
};


// ============================================================
// FUNCIÓN: ELIMINAR ARCHIVO (Con Captcha)
// ============================================================
const eliminarArchivo = async () => {
  showMenuArchivo.value = false;

  // Generar captcha numérico aleatorio de 4 dígitos
  const captchaGenerado = Math.floor(1000 + Math.random() * 9000).toString();

  const result = await Swal.fire({
    title: 'Eliminar Archivo',
    html: `
      <div style="text-align: left; padding: 10px 0;">
        <div style="display: flex; align-items: center; margin-bottom: 20px;">
          <label style="font-weight: bold; margin-right: 15px; min-width: 60px;">Captcha</label>
          <span style="font-size: 24px; font-weight: bold; letter-spacing: 3px;">${captchaGenerado}</span>
        </div>
        <input 
          type="text" 
          id="captcha-input" 
          class="swal2-input" 
          placeholder="Ingrese el captcha"
          style="width: 100%; margin: 0;"
          maxlength="4"
        >
        <p style="margin-top: 15px; color: #666; font-size: 13px;">
          Archivo: <strong>${archivoContexto.value.name}</strong>
        </p>
      </div>
    `,
      // Color del título
        customClass: {
          title: 'swal-title-custom',
          confirmButton: '#ce501b',   // ← agrega esto
          cancelButton: '#9B9B9B',     // ← agrega esto
          customClass: {
           title: 'swal-title-custom',
           container: 'swal-sobre-modal',
           confirmButton: 'swal-btn-confirmar',
           cancelButton: 'swal-btn-cancelar'
         },
        },
    showCancelButton: true,
    confirmButtonText: 'Eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#ce501b',
    cancelButtonColor: '#9B9B9B',
    reverseButtons: false,
    focusConfirm: false,
    preConfirm: () => {
      const captchaIngresado = document.getElementById('captcha-input').value;
      
      if (!captchaIngresado) {
        Swal.showValidationMessage('Debe ingresar el captcha');
        return false;
      }
      
      if (captchaIngresado !== captchaGenerado) {
        Swal.showValidationMessage('El captcha no coincide');
        return false;
      }
      
      return true;
    }
  });

  if (result.isConfirmed) {
    try {
      const idUsuarioSesion = localStorage.getItem('idUsuario');
      
      // Obtener plantillaId del archivo o de la carpeta seleccionada
      let plantillaId = archivoContexto.value.templateId;
      
      if (!plantillaId || plantillaId === 0) {
        plantillaId = selectedFolderTemplateId.value;
      }

      // Validar que tengamos plantillaId
      if (!plantillaId || plantillaId === 0) {
        Swal.fire({
          icon: 'warning',
          iconColor: '#ce501b',
          title: 'Sin plantilla',
          text: 'No se pudo determinar la plantilla del archivo',
          customClass: {
            title: 'swal-title-custom',
            container: 'swal-sobre-modal'
          }
        });
        return;
      }

      Swal.fire({
        title: 'Eliminando archivo...',
        customClass: {
          title: 'swal-title-custom',
          loader: 'swal-loader-custom',
          container: 'swal-sobre-modal'
        },
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const response = await axios.delete(
        `/api/Doc/eliminar-documento/${archivoContexto.value.tocId}?plantillaId=${plantillaId}&idUsuarioSesion=${idUsuarioSesion}`
      );

      if (response.data.success) {
        await Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Eliminado!',
          text: 'El archivo ha sido eliminado',
          confirmButtonColor: '#ce501b',
          customClass: {
           title: 'swal-title-custom',
           confirmButton: 'swal-btn-confirmar',
           container: 'swal-sobre-modal'
          },
          timer: 2000,
          showConfirmButton: false
        });

        // Recargar archivos de la carpeta actual
        if (selectedFolder.value) {
          await loadFilesForFolder(selectedFolder.value.tocId);
        }
      } else {
        throw new Error(response.data.mensaje);
      }

    } catch (error) {
      //console.error('Error al eliminar:', error);   //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
        text: error.response?.data?.mensaje || 'No se pudo eliminar el archivo'
      });
    }
  }
};


const eliminarArchivoLista = (index) => {
  archivosNuevaVersion.value.splice(index, 1);
};


const cargarCarpetasPadre = async () => { 
  //try {   //Usarlo solo para ver los errores en el testeo de Software
    const idUsuarioSesion = localStorage.getItem('idUsuario')

    const response = await axios.get(`/api/Toc/CarpetaPadre/0/${idUsuarioSesion}`);
    carpetasPadre.value = response.data;
    
    // ✅ CREAR NODO RAÍZ VIRTUAL que envuelve las carpetas
    const nodoRaizVirtual = {
      tocId: 0,                          // ID virtual
      parentId: null,                    // Sin padre
      name: 'DIRECTORIO PRINCIPAL',      // Nombre que se muestra
      volId: carpetasPadre.value.length > 0 ? carpetasPadre.value[0].volId : 1,
      templateId: 0,
      tipo: 'r',                         // ✅ Tipo raíz
      version: null,
      fecha_Modificacion: null,
      nivel: null,
      ruta: null,
      fecha_Creacion: null,
      children: carpetasPadre.value.map(carpeta => ({
        ...carpeta,
        children: [],
        childrenLoaded: false
      })),
      childrenLoaded: true               // Ya cargamos sus hijos
    };
    
    // ✅ El árbol es el nodo virtual con sus hijos
    treeData.value = [nodoRaizVirtual];
    
    //console.log('Árbol con nodo raíz virtual:', treeData.value);
  /* //Usarlo solo para ver los errores en el testeo de Software
  } catch (error) {
    console.error('Error al cargar carpetas padre:', error);
  }
  */
};


// Función utilizada para carpeta Hijo .- Consume el API subcarpetas
const handleLoadSubcarpetas = async (tocId) => {
  console.log('[ARBOL] solicitando subcarpetas', {
    tocId,
    tipoTocId: typeof tocId,
    enCache: subcarpetasCache.value.has(tocId),
    cargando: loadingNodes.value.has(tocId)
  })

  if (loadingNodes.value.has(tocId) || subcarpetasCache.value.has(tocId)) return; //Este es una condicional para detectar nodos actualizados y nodos en cache 
  
  loadingNodes.value.add(tocId); //Agrega el valor del nodo y lo carga, obviamente usa el tocId ya que el tocId es para nodos actualizadas
  try {  //Este es un Try Catch para capturar errores
    const response = await axios.get(`/api/Toc/Subcarpetas/${tocId}`); //Esta Api llama a las Subcarpetas y archivo con el parametro tocId pero el API lo recibe con el parentId
    const subcarpetas = response.data;
    subcarpetasCache.value.set(tocId, subcarpetas); //almacena las subcarpetas en memoria cache
    const nodoActualizado = updateNodeChildren(treeData.value, tocId, subcarpetas); //Estructura los datos del árbol carpetas, subcarpetas y archivos --> Datos actualizados
  //} catch (error) {
    //console.error(`Error al cargar subcarpetas para tocId ${tocId}:`, error);    //Usarlo solo para ver los errores en el testeo de Software

  } finally {
    loadingNodes.value.delete(tocId);
  }
};

// ✅ AGREGAR ESTA FUNCIÓN AQUÍ
// Función para forzar recarga de subcarpetas (limpia cache y recarga)
// ✅ REEMPLAZAR ESTA FUNCIÓN COMPLETA:
const handleReloadSubcarpetas = async (tocId) => {
  //console.log('🔄 Recargando subcarpetas para tocId:', tocId);    //Usarlo solo para ver los errores en el testeo de Software
  
  // ✅ CASO ESPECIAL: Si es el nodo raíz virtual (tocId = 0)
  if (tocId === 0) {
    //console.log('Recargando nodo raíz virtual...');    //Usarlo solo para ver los errores en el testeo de Software
    
    // ✅ LIMPIAR TODO EL CACHE COMPLETAMENTE
    subcarpetasCache.value.clear();
    loadingNodes.value.clear();
    
    // ✅ Forzar que treeData sea un array nuevo (nueva referencia)
    openedGroups.value = [];
    treeData.value = [];
    
    // ✅ Esperar un tick para que Vue detecte el cambio
    await new Promise(resolve => setTimeout(resolve, 50));
    
    // ✅ Recargar todo el árbol
    await cargarCarpetasPadre();
    
    // ✅ Forzar que el directorio principal quede expandido
    await nextTick();
    openedGroups.value = [0];

    //console.log('✅ Nodo raíz virtual recargado');             //Usarlo solo para ver los errores en el testeo de Software
    //console.log('Árbol después de recargar:', treeData.value);  //Usarlo solo para ver los errores en el testeo de Software
    return;
  }

  
  // Limpiar cache para este nodo específico
  subcarpetasCache.value.delete(tocId);
  loadingNodes.value.delete(tocId);
  
  // Marcar como no cargadas
  const markAsNotLoaded = (nodes) => {
    for (let node of nodes) {
      if (node.tocId === tocId) {
        node.childrenLoaded = false;
        //node.children = [];
        return true;
      }
      if (node.children && node.children.length > 0) {
        if (markAsNotLoaded(node.children)) return true;
      }
    }
    return false;
  };
  
  markAsNotLoaded(treeData.value);
  
  // Recargar subcarpetas
  await handleLoadSubcarpetas(tocId);
  
  //console.log('✅ Subcarpetas recargadas');   //Usarlo solo para ver los errores en el testeo de Software
};

const handleFolderMoveRequested = async ({ tocId, parentId }) => {
  if (movingFolder.value) return;

  movingFolder.value = true;
  try {
    const response = await axios.put('/api/Toc/mover-carpeta', {
      tocId,
      parentId
    });

    if (!response.data?.success) {
      throw new Error(response.data?.mensaje || 'No se pudo mover la carpeta');
    }

    await handleReloadSubcarpetas(0);
  } catch (error) {
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: error.response?.data?.mensaje || error.message || 'No se pudo mover la carpeta',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal'
      }
    });
  } finally {
    movingFolder.value = false;
  }
};



// FUNCIÓN ACTUALIZADA: Manejar selección de carpeta
const handleFolderSelected = async (folder) => {
  selectedFolder.value = folder;
  selectedFolderTemplateId.value = folder.templateId; //GUARDAR templateId
  
  //console.log('Carpeta seleccionada:', folder.name);   //Usarlo solo para ver los errores en el testeo de Software
  //console.log('Template ID:', folder.templateId);   //Usarlo solo para ver los errores en el testeo de Software
  
  actualizarPermisoCarpetaActual(folder.tocId);   // ← NUEVA LÍNEA

  await loadFilesForFolder(folder.tocId);
};


const cargarEstructuraDinamica = async (templateId) => {
  estructuraDinamica.value = [];
  
  // Headers base siempre presentes
  const headersBase = [{ title: 'Nombre', key: 'name', sortable: true }];
  const headerFinal = [{ title: 'Peso', key: 'peso', sortable: true }];
  
  if (!templateId || templateId === 0) {
    fileHeaders.value = [...headersBase, ...headerFinal];
    return;
  }

  try {
    const response = await axios.get(
      `/api/Plantillas/estructura/${templateId}`
    );

    if (response.data.success && response.data.data.length > 0) {
      estructuraDinamica.value = response.data.data;

      // Construir headers dinámicos
      const headersDinamicos = response.data.data.map(campo => ({
        title: campo.column_name,
        key: 'dyn_' + campo.column_name,
        sortable: true
      }));

      fileHeaders.value = [...headersBase, ...headersDinamicos, ...headerFinal];
      //console.log('Headers actualizados:', fileHeaders.value);       //Usarlo solo para ver los errores en el testeo de Software
    } else {
      fileHeaders.value = [...headersBase, ...headerFinal];
    }
  } catch (error) {
    //console.error('Error al cargar estructura dinámica:', error);     //Usarlo solo para ver los errores en el testeo de Software
    fileHeaders.value = [...headersBase, ...headerFinal];
  }
};

// FUNCIÓN CORREGIDA: Cargar archivos de una carpeta

const loadFilesForFolder = async (tocId) => {
  loadingFiles.value = true;
  filesInSelectedFolder.value = [];

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    const plantilla = selectedFolderTemplateId.value ?? 0;

    // ✅ Un solo request al SP — ya trae nombre + metadatos + peso juntos
    const response = await axios.get(
      `/api/Indexacion/obtener-archivos/${tocId}`,
      { params: { idUsuarioSesion, plantilla } }
    );

    if (!response.data.success) {
      filesInSelectedFolder.value = [];
      return;
    }

    const filas = response.data.data; // array de objetos planos del SP

    // ── Detectar templateId desde los datos (el SP lo devuelve en "plantillaid") ──
    if (filas.length > 0 && filas[0].plantillaid) {
      const templateDetectado = parseInt(filas[0].plantillaid);
      if (templateDetectado > 0) {
        selectedFolderTemplateId.value = templateDetectado;
      }
    }

    // ── Cargar estructura dinámica (solo para saber qué columnas mostrar) ──
    await cargarEstructuraDinamica(selectedFolderTemplateId.value);
    await cargarNombrePlantilla(selectedFolderTemplateId.value);

    // ── Columnas fijas que el SP devuelve y NO son metadatos dinámicos ──
    const columnasReservadas = new Set([
      'TocPrincipal', 'Documento', 'version',
      'plantillaid', 'indexado', 'IdTipoPer', 'workflow', 'PESO'
    ]);

    // ── Mapear cada fila a la forma que espera la tabla ──
    const archivos = filas.map(fila => {
      const archivo = {
        tocId:      fila['TocPrincipal'],
        name:       fila['Documento'],
        templateId: parseInt(fila['plantillaid'] ?? 0),
        peso:       fila['PESO'] ?? null,
        indexado:   fila['indexado'] === 1,
        tipo:       'd'
      };

      // Mapear columnas dinámicas con prefijo dyn_
      for (const [col, val] of Object.entries(fila)) {
        if (!columnasReservadas.has(col)) {
          archivo['dyn_' + col] = val ?? '';
        }
      }

      return archivo;
    });

    // ── Ordenar: primero indexados, luego por nombre ──
    archivos.sort((a, b) => {
      if (a.indexado && !b.indexado) return -1;
      if (!a.indexado && b.indexado) return 1;
      return (a.name ?? '').localeCompare(b.name ?? '');
    });

    filesInSelectedFolder.value = archivos;

  } catch (error) {
    filesInSelectedFolder.value = [];
  } finally {
    loadingFiles.value = false;
  }
};


//Funcion de nodos actualizados hijos recursiva
const updateNodeChildren = (nodes, targetTocId, newChildren) => {
  //parametros: 
  //nodes .- representa el nodo de arbol actual
  //targetTocId .- nodo para agregarle hijos nuevos  
  //newChildren .- Array de nuevos nodos hijos
    for (let node of nodes) {
    if (node.tocId === targetTocId) {
      const hijosExistentes = node.children || []; // ✅ guardar los hijos actuales con sus subárboles
      node.children = newChildren.map(child => {
        // ✅ Si este hijo ya existía y tenía sus subcarpetas cargadas, preservar su subárbol completo
        const existente = hijosExistentes.find(c => c.tocId === child.tocId);
        if (existente && existente.childrenLoaded) {
          return {
            ...child,
            children: existente.children,       // preserva nietos (y más profundo)
            childrenLoaded: true
          };
        }
        // Hijo nuevo (como la carpeta recién creada): vacío y sin cargar
        return {
          ...child,
          children: [],
          childrenLoaded: false
        };
      });
      node.childrenLoaded = true;
      return true;
    }

    // ✅ RECURSIÓN (esto es lo que se había perdido): si no es este nodo, buscar dentro de sus hijos
    if (node.children && node.children.length > 0) {
      if (updateNodeChildren(node.children, targetTocId, newChildren)) return true;
    }
  }
  return false; // recorrió todo el árbol y no encontró el nodo
};

// Filtro de búsqueda
const filteredItems = computed(() => { //Esto sirve para el filtro de busqueda para mayuscula
  if (!search.value) return treeData.value; //busca el nodo y lo retorna el valor en treeData que significa estructura de carpeta y subcarpeta
  const searchText = caseSensitive.value ? search.value : search.value.toLowerCase(); //filtro de nodos en minuscula
  
  const filterTree = (nodes) => { //filtro de nodos en arboles
    return nodes.reduce((filtered, node) => { //retornamos los nodos para reducir su valor
      const nodeName = caseSensitive.value ? node.name : node.name.toLowerCase(); //El ? es la forma abreviada de escribir un If Else, signifca buscar en Mayuscula sensitive o minuscula
      const isNodeMatch = nodeName.includes(searchText); //tomamos la variable para incluir al nombre del nodo y ser usado
      
      // Filtrar hijos recursivamente si existen
      let filteredChildren = [];
      if (node.children && node.children.length > 0) {
        filteredChildren = filterTree(node.children);
      }
      
      // Incluir el nodo si:
      // 1. El nodo coincide con la búsqueda, O
      // 2. Tiene hijos que coinciden con la búsqueda

      if (isNodeMatch || filteredChildren.length > 0) {
        filtered.push({
          ...node, //sirve para copiar todas las propiedades del objeto node
          children: filteredChildren //filtro de nodos hijas
        });
      }
      
      return filtered;
    }, []);
  };
  
  return filterTree(treeData.value);
});


// ============================================================
// VARIABLES PARA MENÚ CONTEXTUAL DE VERSIONES
// ============================================================
const showMenuVersion = ref(false);
const menuVersionX = ref(0);
const menuVersionY = ref(0);
const versionSeleccionada = ref(null);


// ============================================================
// FUNCIONES PARA MENÚ CONTEXTUAL DE VERSIONES
// ============================================================

// Abrir menú contextual de versión
const abrirMenuVersion = (event, version) => {
  event.preventDefault();
  versionSeleccionada.value = version;
  menuVersionX.value = event.clientX;
  menuVersionY.value = event.clientY;
  showMenuVersion.value = true;
};


// Descargar versión en formato original
const descargarVersionOriginal = async () => {
  showMenuVersion.value = false;
  
  if (!versionSeleccionada.value) return;

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario');
    const itemVersion = versionSeleccionada.value.item;

    Swal.fire({
      title: 'Descargando archivo...',
      html: 'Preparando descarga...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
       customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal',
          loader: 'swal-loader-custom'
        },
    });

    const response = await axios.get(
      `/api/Version/descarga-formato-original/${itemVersion}?idUsuarioSesion=${idUsuarioSesion}`,
      { responseType: 'blob' }
    );

    // ✅ Obtener nombre del archivo del header Content-Disposition
    let nombreArchivo = `version_${versionSeleccionada.value.version}`;
    const contentDisposition = response.headers['content-disposition'];
    
    if (contentDisposition) {
      // Buscar filename en el header
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=["']?([^"';\n]+)["']?/i);
      if (filenameMatch && filenameMatch[1]) {
        nombreArchivo = filenameMatch[1].trim();
      }
    }

    // ✅ Si aún no tiene extensión, intentar obtenerla del content-type
    if (!nombreArchivo.includes('.')) {
      const contentType = response.headers['content-type'];
      const extension = getExtensionFromContentType(contentType);
      if (extension) {
        nombreArchivo += extension;
      }
    }

    // Crear enlace de descarga
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    Swal.fire({
      icon: 'success',
      iconColor: '#ce501b',
      title: '¡Descargado!',
      text: 'El archivo se ha descargado correctamente',
      timer: 2000,
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      showConfirmButton: false
    });

  } catch (error) {
    //console.error('Error al descargar versión:', error);   //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
      text: error.response?.data?.mensaje || 'No se pudo descargar el archivo'
    });
  }
};

// ✅ Función auxiliar para obtener extensión del content-type
const getExtensionFromContentType = (contentType) => {
  if (!contentType) return '';
  
  const mimeToExt = {
    'application/pdf': '.pdf',
    'application/msword': '.doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    'application/vnd.ms-excel': '.xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/gif': '.gif',
    'image/tiff': '.tiff',
    'text/plain': '.txt',
    'application/zip': '.zip',
    'application/xml': '.xml',
    'application/json': '.json'
  };

  return mimeToExt[contentType] || '';
};


// ── Atajo de teclado para Indexación de Archivo ──
const handleKeyboardShortcutArchivo = (event) => {
  if (!dialogIndexarArchivo.value) return

  // ✅ Espacio → play/pause en video o audio
  if (event.key === ' ' || event.code === 'Space') {
    const tag = (event.target?.tagName || '').toUpperCase()
    // Solo actuar si el foco NO está en un input/textarea/button
    const editando = ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'].includes(tag)
    if (!editando) {
      event.preventDefault()
      const media = document.querySelector(
        '.dialog-indexacion video, .dialog-indexacion audio'
      )
      if (media) {
        if (media.paused) {
          media.play().catch(() => {}) // Ignorar error si no se puede reproducir
        } else {
          media.pause()
        }
      }
    }
    return
  }

  // Ctrl + Alt + G → Guardar indexación de archivo
  if (event.ctrlKey && event.altKey && event.key === 'g') {
    event.preventDefault()
    if (!modoVisualizacion.value) {
      guardarIndexacionArchivo()
    }
    return
  }

  // ESC → Cerrar modal de indexación de archivo
  if (event.key === 'Escape') {
    event.preventDefault()
    dialogIndexarArchivo.value = false
    return
  }

  // ✅ Detectar si el usuario está escribiendo en un input/textarea/select del formulario
  const tag = (event.target?.tagName || '').toUpperCase()
  const editando = ['INPUT', 'TEXTAREA', 'SELECT'].includes(tag) ||
                   event.target?.isContentEditable

  // ✅ Flechas izquierda/derecha → navegar páginas (solo en modo multi-página)
  if (modoPaginasMultiples.value && !editando && !cargandoPaginaMultiple.value) {
    if (event.key === 'ArrowRight') {
      event.preventDefault()
      if (paginaMultipleActual.value < listaPaginas.value.length) {
        cargarPaginaMultiple(paginaMultipleActual.value + 1)
      }
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault()
      if (paginaMultipleActual.value > 1) {
        cargarPaginaMultiple(paginaMultipleActual.value - 1)
      }
    } else if (event.key === 'Home') {
      event.preventDefault()
      cargarPaginaMultiple(1)
    } else if (event.key === 'End') {
      event.preventDefault()
      cargarPaginaMultiple(listaPaginas.value.length)
    }
  }
}



// Descargar versión en formato PDF

onMounted(async () => { //hook del ciclo de vida se usa cuando ya fue montado en el DOM, sirve para que este visible en la pantalla
  await cargarCarpetasPadre(); //carga de datos Asincrono
  await sincronizarTablaTrasImport(pendingReloadTocId.value); //carga de datos Asincrono
  AccesoExportar.value = Number(localStorage.getItem('exportacion')) === 1;
  AccesoAnotacion.value = Number(localStorage.getItem('anotaciones')) === 1; 
  AccesoImprimir.value = Number(localStorage.getItem('impresion')) === 1;
  esAdmin.value = localStorage.getItem('idUsuario') === '00001';   // ← NUEVA
  await cargarPermisosUsuario();                                   // ← NUEVA

  // ✅ Registrar atajo de teclado
  document.addEventListener('keydown', handleKeyboardShortcutArchivo)
});

onUnmounted(() => {
  // ✅ Limpiar atajo de teclado
  document.removeEventListener('keydown', handleKeyboardShortcutArchivo);
  if (zoomDebounceTimer) clearTimeout(zoomDebounceTimer);
  zoomDebounceTimer = null;

  const container = pdfScrollContainer.value;
  if (pointerIdArrastrePdf !== null && container?.hasPointerCapture?.(pointerIdArrastrePdf)) {
    container.releasePointerCapture(pointerIdArrastrePdf);
  }
  pointerIdArrastrePdf = null;
  isDraggingArchivo.value = false;

  const tareas = Object.values(renderTasks.value);
  renderTasks.value = {};
  for (const task of tareas) {
    try { task.cancel?.(); } catch (e) { void e; }
  }
  const pdfAlDesmontar = pdfDocumento.value;
  Promise.allSettled(tareas.map(task => task?.promise)).then(() => pdfAlDesmontar?.destroy?.());

  pdfDocumento.value = null;
  zoomArchivoLevel.value = 1;
  zoomRenderPagina.value = {};
  dimsBasePaginas.value = {};
  paginasRenderizadas.value = new Set();
})

// ============================================================
// VARIABLES PARA EXPORTAR
// ============================================================
const dialogExportar = ref(false);
const exportarDesde = ref(1);
const exportarHasta = ref(9999);
const exportarConCertificado = ref(false);
const exportandoArchivo = ref(false);



// Opciones de páginas (valores fijos del 1 al 100)
const opcionesPaginas = computed(() => {
  const paginas = [];
  for (let i = 1; i <= 100; i++) {
    paginas.push({ texto: `${i}`, valor: i });
  }
  return paginas;
});

// Opciones de páginas para "Hasta" (desde la página seleccionada)
const opcionesPaginasHasta = computed(() => {
  const paginas = [];
  const inicio = exportarDesde.value || 1;
  for (let i = inicio; i <= 100; i++) {
    paginas.push({ texto: `${i}`, valor: i });
  }
  return paginas;
});

/*
const exportarArchivo = () => {
  showMenuArchivo.value = false;
  
  // Resetear valores
  exportarDesde.value = 1;
  exportarHasta.value = 9999;
  exportarConCertificado.value = false;
  
  // Abrir dialog
  dialogExportar.value = false;
};
*/


const esArchivoExportablePDF = computed(() => {
  if (!archivoContexto.value?.name) return true
  const ext = archivoContexto.value.name.split('.').pop().toLowerCase()
  return ext === 'pdf'
})



const confirmarExportar = async () => {
  dialogExportar.value = false
  showMenuArchivo.value = false

  const ext = (archivoContexto.value?.name || '').split('.').pop().toLowerCase()
  const esVideoAudio = [...extensionesVideo, ...extensionesAudioVisor].includes(ext)
  const idUsuarioSesion = localStorage.getItem('idUsuario');


  // ── Caso 1: video/audio → descargar el archivo original tal cual ──
  if (esVideoAudio) {
    let plantillaId = archivoContexto.value.templateId
    if (!plantillaId || plantillaId === 0) plantillaId = selectedFolderTemplateId.value

    procesarDescargaArchivo({
      url: `/api/Indexacion/ver-documento/${archivoContexto.value.tocId}/${idUsuarioSesion}/${plantillaId}`,
      nombre: archivoContexto.value.name
    })
    return
  }

  // ── Caso 2: PDF (con o sin certificado) ──
  
  let plantillaId = archivoContexto.value.templateId
  if (!plantillaId || plantillaId === 0) plantillaId = selectedFolderTemplateId.value

  if (!plantillaId || plantillaId === 0) {
    Swal.fire({
      icon: 'warning', iconColor: '#ce501b', title: 'Sin plantilla',
      text: 'No se pudo determinar la plantilla del archivo',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    })
    return
  }

  // con eso va usar el nombre real con su extensión.
  const nombreSugerido = archivoContexto.value.name || `documento_${archivoContexto.value.tocId}`

  procesarDescargaArchivo({
    url: `/api/Doc/descargar?idUsuarioSesion=${idUsuarioSesion}`,
    metodo: 'post',
    nombre: nombreSugerido,
    body: {
      toc: archivoContexto.value.tocId,
      plantilla: plantillaId,
      desde: exportarDesde.value,
      hasta: exportarHasta.value
    }
  })
}




// Cargar anotaciones existentes al abrir el visor
const cargarAnotaciones = async (tocId) => {

   
  //try {    //Usarlo solo para ver los errores en el testeo de Software
    const response = await axios.get(
      `/api/Indexacion/obtener-anotaciones/${tocId}`
    );
    if (response.data.success) {
      //console.log('Anotaciones recibidas:', response.data.data);   //Usarlo solo para ver los errores en el testeo de Software
      anotaciones.value = response.data.data;
    }
  /*   
  //Usarlo solo para ver los errores en el testeo de Software
  } catch (error) {   
    console.error('Error al cargar anotaciones:', error);
  }  */
   
};

// Click sobre el visor para agregar anotación
const agregarAnotacion = (event) => {
  if (!modoAnotacion.value) return;
  
  // Si ya hay una nota abierta, ignorar
  if (nuevaAnotacionVisible.value) return;
  
  event.stopPropagation();

  const visorDiv = event.currentTarget;
  const rect = visorDiv.getBoundingClientRect();
  
  const x = ((event.clientX - rect.left) / rect.width) * 100;
  const y = ((event.clientY - rect.top) / rect.height) * 100;

  nuevaAnotacionX.value = parseFloat(x.toFixed(2));
  nuevaAnotacionY.value = parseFloat(y.toFixed(2));
  nuevaAnotacionTexto.value = '';
  nuevaAnotacionVisible.value = true;
  editandoAnotacionIndex.value = null;

  // Forzar focus en el textarea después de renderizar
  setTimeout(() => {
    const textarea = document.getElementById('sticky-note-input');
    if (textarea) textarea.focus();
  }, 100);
};


// Confirmar nueva anotación desde el sticky note
const confirmarAnotacion = () => {
  if (!nuevaAnotacionTexto.value.trim()) {
    cancelarAnotacion();
    return;
  }

  if (editandoAnotacionIndex.value !== null) {
    // Editando una existente
    anotaciones.value[editandoAnotacionIndex.value].texto = nuevaAnotacionTexto.value.trim();
  } else {
    // Nueva anotación
    anotaciones.value.push({
      tocId: archivoContexto.value.tocId,
      texto: nuevaAnotacionTexto.value.trim(),
      x: nuevaAnotacionX.value,
      y: nuevaAnotacionY.value
    });
  }

  cancelarAnotacion();
};


// Cancelar/cerrar sticky note
const cancelarAnotacion = () => {
  nuevaAnotacionVisible.value = false;
  nuevaAnotacionTexto.value = '';
  editandoAnotacionIndex.value = null;
};


// Editar anotación existente (abrir sticky note con su texto)
const editarAnotacion = (index) => {
  const anot = anotaciones.value[index];
  nuevaAnotacionX.value = anot.x;
  nuevaAnotacionY.value = anot.y;
  nuevaAnotacionTexto.value = anot.texto;
  editandoAnotacionIndex.value = index;
  nuevaAnotacionVisible.value = true;

  setTimeout(() => {
    const textarea = document.getElementById('sticky-note-input');
    if (textarea) textarea.focus();
  }, 100);
};




// Guardar todas las anotaciones en BD
const guardarAnotaciones = async () => {
  try {
    const nombreUsuario = localStorage.getItem('nombreUsuario');
    let templateId = archivoContexto.value.templateId || selectedFolderTemplateId.value;

    const response = await axios.post(
      `/api/Indexacion/guardar-anotaciones?idUsuarioSesion=${nombreUsuario}`,
      {
        tocId: archivoContexto.value.tocId,
        plantillaId: templateId,
        anotaciones: anotaciones.value
      }
    );

    if (response.data.success) {
      modoAnotacion.value = false;
      Swal.fire({
        icon: 'success',
        iconColor: '#ce501b',
        title: '¡Guardado!',
        text: response.data.mensaje,
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        }
      });
    }
  } catch (error) {
    //console.error('Error al guardar anotaciones:', error);      //Usarlo solo para ver los errores en el testeo de Software
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error',
      text: 'No se pudieron guardar las anotaciones',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal'
      }
    });
  }
};


// Eliminar anotación específica
const eliminarAnotacion = async (index) => {
  const anot = anotaciones.value[index];

  // Si la anotación tiene item (existe en BD), llamar API
  if (anot.item) {
    try {
      const idUsuarioSesion = localStorage.getItem('nombreUsuario');

      const response = await axios.delete(
        `/api/Indexacion/eliminar-anotacion/${anot.item}?idUsuarioSesion=${idUsuarioSesion}`
      );

      if (response.data.success) {
        anotaciones.value.splice(index, 1);
        Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Eliminada!',
          text: 'Anotación eliminada correctamente',
          timer: 1500,
          showConfirmButton: false,
          customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
        });
      } else {
        Swal.fire({
          icon: 'error',
          iconColor: '#ce501b',
          title: 'Error',
          text: response.data.mensaje || 'No se pudo eliminar la anotación',
          customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
        });
      }
    } catch (error) {
      //console.error('Error al eliminar anotación:', error);     //Usarlo solo para ver los errores en el testeo de Software
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || 'No se pudo eliminar la anotación',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
    }
  } else {
    // Anotación nueva (aún no guardada en BD), solo quitar del array local
    anotaciones.value.splice(index, 1);
  }
};


const visualizarArchivo = async (archivo) => {
  archivoContexto.value = archivo;

  try {
    let templateId = archivo.templateId;
    if (!templateId || templateId === 0) {
      templateId = selectedFolderTemplateId.value;
    }

    if (!templateId || templateId === 0) {
      Swal.fire({ 
        icon: 'warning',
        iconColor: '#ce501b',
        title: 'Sin plantilla',
        text: 'Este archivo no tiene una plantilla asignada',
        customClass: {
          title: 'swal-title-custom',
          container: 'swal-sobre-modal'
        },
       });
      return;
    }

    // Modo visualización (sin botones guardar/cancelar)
    modoVisualizacion.value = true;

    cargandoEstructuraArchivo.value = true;
    cargandoPdfVisor.value = true;
    errorPdfVisor.value = '';
    urlPdfVisor.value = '';
    anotaciones.value = [];
    modoAnotacion.value = false;


   // ✅ AGREGAR ESTO — igual que en indexarArchivo
    modoPaginasMultiples.value = false
    listaPaginas.value = []
    urlPaginaMultiple.value = ''
    paginaMultipleActual.value = 1

    dialogIndexarArchivo.value = true;
    zoomArchivoLevel.value = 1

    const [responseEstructura] = await Promise.all([
      axios.get(`/api/Plantillas/estructura/${templateId}`),
      cargarPdfVisor(archivo.tocId, templateId)
    ]);
    await cargarAnotaciones(archivo.tocId);
    cargandoEstructuraArchivo.value = false;

    if (responseEstructura.data.success && responseEstructura.data.data.length > 0) {
      estructuraPlantillaArchivo.value = responseEstructura.data.data;

      valoresIndexacionArchivo.value = {};
      estructuraPlantillaArchivo.value.forEach(campo => {
        valoresIndexacionArchivo.value[campo.column_name] = '';
      });

      await cargarValoresIndexacionExistentes(archivo.tocId, templateId);
    }

  } catch (error) {
    cargandoEstructuraArchivo.value = false;
    cargandoPdfVisor.value = false;
    //console.error('Error al visualizar archivo:', error);   //Usarlo solo para ver los errores en el testeo de Software
  }
};

// Función de impresión
// Función de impresión
const imprimirPDF = async () => {
  // ── Caso 1: documento normal (ya es un PDF cargado en el visor) ──
  if (!modoPaginasMultiples.value) {
    if (urlPdfVisor.value) {
      const ventana = window.open(urlPdfVisor.value, '_blank')
      if (ventana) {
        ventana.onload = () => {
          setTimeout(() => { ventana.print() }, 500)
        }
      } else {
        window.open(urlPdfVisor.value, '_blank')
      }
    }
    return
  }

  // ── Caso 2: imágenes multipágina → unificar en PDF temporal e imprimir ──
  if (!listaPaginas.value.length) return

  Swal.fire({
    title: 'Preparando impresión...',
    text: 'Unificando páginas en un PDF',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
    customClass: { container: 'swal-sobre-modal' }
  })

  try {
    const idUsuarioSesion = localStorage.getItem('idUsuario')
    const tocId = archivoContexto.value.tocId
    const plantillaId = archivoContexto.value.templateId || selectedFolderTemplateId.value

    const response = await axios.post(
      `/api/Doc/descargar?idUsuarioSesion=${idUsuarioSesion}`,
      {
        toc: tocId,
        plantilla: plantillaId,
        desde: 1,
        hasta: listaPaginas.value.length
      },
      { responseType: 'blob' }
    )

    const pdfBlobUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))

    Swal.close()

    const ventana = window.open(pdfBlobUrl, '_blank')
    if (ventana) {
      ventana.onload = () => {
        setTimeout(() => {
          ventana.print()
          setTimeout(() => URL.revokeObjectURL(pdfBlobUrl), 30000)
        }, 500)
      }
    } else {
      URL.revokeObjectURL(pdfBlobUrl)
      Swal.fire({
        icon: 'warning', iconColor: '#ce501b', title: 'Popup bloqueado',
        text: 'Permite ventanas emergentes para imprimir',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      })
    }
  } catch (error) {
    Swal.close()
    Swal.fire({
      icon: 'error', iconColor: '#e24b4a', title: 'Error al imprimir',
      text: error.response?.data?.mensaje || 'No se pudo generar el PDF para impresión',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    })
  }
}





const exportandoExcel = ref(false);

const exportarExcel = () => {
  if (!filesInSelectedFolder.value.length) return;
  exportandoExcel.value = true;

  try {
    // ── 1. Construir encabezados ──
    const encabezados = ['Nombre'];
    for (const campo of estructuraDinamica.value) {
      encabezados.push(campo.column_name);
    }
    encabezados.push('Peso (MB)');

    // ── 2. Construir filas con TODOS los registros ──
    const filas = filesInSelectedFolder.value.map(item => {
      const fila = [item.name];
      for (const campo of estructuraDinamica.value) {
        const valor = item['dyn_' + campo.column_name];
        fila.push(formatearValorDinamico(valor, campo.data_type));
      }
      fila.push(parseFloat(item.peso || 0).toFixed(2));
      return fila;
    });

    // ── 3. Armar hoja ──
    const datos = [encabezados, ...filas];
    const hoja = XLSX.utils.aoa_to_sheet(datos);

    // Ajustar ancho de columnas automáticamente
    const anchos = encabezados.map((enc, colIdx) => {
      const maxLen = Math.max(
        enc.length,
        ...filas.map(fila => String(fila[colIdx] ?? '').length)
      );
      return { wch: Math.min(maxLen + 2, 50) };
    });
    hoja['!cols'] = anchos;

    // Estilo de encabezado (negrita)
    encabezados.forEach((_, colIdx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIdx });
      if (hoja[cellRef]) {
        hoja[cellRef].s = { font: { bold: true } };
      }
    });

    // ── 4. Crear libro y descargar ──
    const libro = XLSX.utils.book_new();
    const nombreHoja = selectedFolder.value?.name?.substring(0, 31) || 'Archivos';
    XLSX.utils.book_append_sheet(libro, hoja, nombreHoja);

    const nombreArchivo = `${selectedFolder.value?.name || 'archivos'}_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(libro, nombreArchivo);

    Swal.fire({
      icon: 'success',
      iconColor: '#ce501b',
      title: '¡Exportado!',
      html: `Se exportaron <strong>${filas.length}</strong> registros correctamente`,
      timer: 2000,
      showConfirmButton: false,
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });

  } catch (error) {
    Swal.fire({
      icon: 'error',
      iconColor: '#ce501b',
      title: 'Error al exportar',
      text: error.message || 'No se pudo generar el archivo Excel',
      customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
    });
  } finally {
    exportandoExcel.value = false;
  }
};




const formatearPesoMB = (peso) => {
  if (!peso || peso === 0) return '0 MB';
  return parseFloat(peso).toFixed(2) + ' MB';
};


const enviarCorreo = async () => {

  dialogIndexarArchivo.value = false;

  if (!archivoContexto.value) return;

  const email = localStorage.getItem('Email');
  if (!email) {
    Swal.fire({
      icon: 'warning',
      iconColor: '#ce501b',
      title: 'Sin correo',
      text: 'No se encontró un correo asociado a su cuenta',
       confirmButtonColor: '#ce501b',
      customClass: { title: 'swal-title-custom',  confirmButton: 'swal-btn-confirmar', container: 'swal-sobre-modal' }
    });
    return;
  }

  // Verificar tamaño del archivo (peso viene en MB desde la tabla)
  const pesoMB = parseFloat(archivoContexto.value.peso) || 0;

  if (pesoMB > 25) {
    // ── PLAN B: Archivo grande → pedir link de Drive ──
    const { value: linkDrive } = await Swal.fire({
      title: 'Documento supera los 25 MB',
      html: `
        <div style="text-align: left; font-size: 14px;">
          <p><strong>Archivo:</strong> ${archivoContexto.value.name}</p>
          <p><strong>Peso:</strong> ${pesoMB.toFixed(2)} MB</p>
          <p style="margin-top: 10px;">Por favor primero, exporte su documento, luego lo sube el documento al Drive, genere su link y cópielo.</p>
          <p style="margin-top: 10px;">Tercero, vuelva al visor("Indexación de Archivo") para darle click al botón Enviar correo, nuevamente se va a abrir el formulario.</p>
          <p style="margin-top: 10px;">Nota: Dar click en el botón Salir para que pueda exportar su documento, <mark> si ya tiene el link de su Drive puede hacer click en el botón continuar. </mark></p>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Salir',
      confirmButtonColor: '#ce501b',
      cancelButtonColor: '#9B9B9B',
      iconColor: '#ce501b',
      icon: 'info',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal',
        confirmButton: 'swal-btn-confirmar',
        cancelButton: 'swal-btn-cancelar'
      },
   
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'Debe ingresar el enlace de Google Drive';
        }
        if (!value.includes('drive.google.com') && !value.includes('docs.google.com') && !value.startsWith('http')) {
          return 'El enlace no parece ser válido. Pegue un enlace de Google Drive.';
        }
      }

    });

    if (!linkDrive) return;

    // Enviar correo con el link de Drive
    try {
      const resultadoDrive = await Swal.fire({
      title: 'Documento supera los 25 MB',
      html: `
        <div style="text-align: left; font-size: 14px;">
          <p><strong>Archivo:</strong> ${archivoContexto.value.name}</p>
          <p><strong>Peso:</strong> ${pesoMB.toFixed(2)} MB</p>
          <p style="margin-top: 10px;">Tercero pega el link donde dice "Pegue aquí el enlace ...."</p>
        </div>
      `,
      input: 'textarea',
      inputPlaceholder: 'Pegue aquí el enlace de Google Drive...',
      inputAttributes: {
        style: 'height: 80px; font-size: 13px;'
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#ce501b',
      cancelButtonColor: '#9B9B9B',
      iconColor: '#ce501b',
      icon: 'info',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal',
        confirmButton: 'swal-btn-confirmar',
        cancelButton: 'swal-btn-cancelar'
      },
    

      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'Debe ingresar el enlace de Google Drive';
        }
        if (!value.includes('drive.google.com') && !value.includes('docs.google.com') && !value.startsWith('http')) {
          return 'El enlace no parece ser válido. Pegue un enlace de Google Drive.';
        }
      }
    });

   if (!resultadoDrive.isConfirmed) return;

   const linkDrive = resultadoDrive.value;


     Swal.fire({
        title: 'Enviando correo...',
        html: 'Preparando y enviando el documento...',
        allowOutsideClick: false,
        customClass: {
          title: 'swal-title-custom',
          loader: 'swal-loader-custom',
          container: 'swal-sobre-modal'
        },
        didOpen: () => { Swal.showLoading(); }
      });

      const idUsuarioSesion = localStorage.getItem('idUsuario');
      const nombreUsuario = localStorage.getItem('nombreUsuario');

      let plantillaId = archivoContexto.value.templateId;
      if (!plantillaId || plantillaId === 0) {
        plantillaId = selectedFolderTemplateId.value;
      }

      const response = await axios.post(
        `/api/Doc/enviar-correo-link?idUsuarioSesion=${idUsuarioSesion}`,
        {
          tocId: archivoContexto.value.tocId,
          plantillaId: plantillaId,
          email: email,
          linkDrive: linkDrive.trim(),
          usuario: nombreUsuario,
        }

      );

      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Enviado!',
          html: `Enlace enviado correctamente a <strong>${email}</strong>`,
          timer: 3000,
          showConfirmButton: false,
          customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
        });
      } else {
        throw new Error(response.data.mensaje);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || error.message || 'No se pudo enviar el correo',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
    }

  } else {
    // ── PLAN A: Archivo normal → adjuntar directo ──
    const result = await Swal.fire({
      title: 'Enviar documento por correo',
      html: `
        <div style="text-align: left;">
          <p><strong>Archivo:</strong> ${archivoContexto.value.name}</p>
          <p><strong>Destinatario:</strong> ${email}</p>
        </div>
      `,
      icon: 'question',
      iconColor: '#ce501b',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#ce501b',
      cancelButtonColor: '#9B9B9B',
      customClass: {
        title: 'swal-title-custom',
        container: 'swal-sobre-modal',
        confirmButton: 'swal-btn-confirmar',
        cancelButton: 'swal-btn-cancelar'
      }
    });

    if (!result.isConfirmed) return;

    try {
      Swal.fire({
        title: 'Enviando correo...',
        html: 'Preparando y enviando el documento...',
        allowOutsideClick: false,
        customClass: {
          title: 'swal-title-custom',
          loader: 'swal-loader-custom',
          container: 'swal-sobre-modal'
        },
        didOpen: () => { Swal.showLoading(); }
      });

      const idUsuarioSesion = localStorage.getItem('idUsuario');
      const nombreUsuario = localStorage.getItem('nombreUsuario');

      let plantillaId = archivoContexto.value.templateId;
      if (!plantillaId || plantillaId === 0) {
        plantillaId = selectedFolderTemplateId.value;
      }

      const response = await axios.post(
        `/api/Doc/enviar-correo?idUsuarioSesion=${idUsuarioSesion}`,
        {
          tocId: archivoContexto.value.tocId,
          plantillaId: plantillaId,
          email: email,
          usuario: nombreUsuario,
        }
      );

      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          iconColor: '#ce501b',
          title: '¡Enviado!',
          html: `Documento enviado correctamente a <strong>${email}</strong>`,
          timer: 3000,
          showConfirmButton: false,
          customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
        });
      } else {
        throw new Error(response.data.mensaje);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        iconColor: '#ce501b',
        title: 'Error',
        text: error.response?.data?.mensaje || error.message || 'No se pudo enviar el correo',
        customClass: { title: 'swal-title-custom', container: 'swal-sobre-modal' }
      });
    }
  }
};


// ✅ Versiones solo para documentos (PDF, imágenes) — NO para video ni audio
const esArchivoConVersiones = computed(() => {
  if (!archivoContexto.value?.name) return true
  const ext = archivoContexto.value.name.split('.').pop().toLowerCase()
  const sinVersiones = [...extensionesVideo, ...extensionesAudioVisor]
  return !sinVersiones.includes(ext)
})



// ── Cargar permisos del usuario (reusa el cache de tree-node) ──
const cargarPermisosUsuario = async () => {
  const idUsuario = localStorage.getItem('idUsuario')
  if (!idUsuario) return
  if (idUsuario === '00001') return

  const cacheKey = `permisosCarpetas_${idUsuario}`

  try {
    const cached = localStorage.getItem(cacheKey)
    if (cached) {
      permisosCarpetas.value = JSON.parse(cached)
      return
    }
  } catch (e) { void e }

  const promiseKey = `__permisosCarpetasPromise_${idUsuario}`
  if (!window[promiseKey]) {
    window[promiseKey] = axios
      .get(`/api/Users/obtener-permiso-carpeta/${idUsuario}`)
      .then(resp => {
        const data = (resp.data?.success && Array.isArray(resp.data.data))
          ? resp.data.data
          : []
        localStorage.setItem(cacheKey, JSON.stringify(data))
        return data
      })
      .catch(() => [])
  }
  try { permisosCarpetas.value = await window[promiseKey] } catch (e) { void e }
}

// ── Calcular el permiso de la carpeta seleccionada (1 = lectura, 2 = escritura) ──
const actualizarPermisoCarpetaActual = (tocId) => {
  if (esAdmin.value) { esTipoPer.value = 2; return }

  if (!Array.isArray(permisosCarpetas.value) || permisosCarpetas.value.length === 0) {
    esTipoPer.value = 0
    return
  }

  const delNodo = permisosCarpetas.value.filter(p => p.tocId === tocId)
  esTipoPer.value = delNodo.length > 0
    ? Math.max(...delNodo.map(p => p.idTipoPer || 0))
    : 0
}

const selectedFolderTemplateName = ref('');   // ← AGREGAR ESTA

const cargarNombrePlantilla = async (templateId) => {
  if (!templateId || templateId === 0) { selectedFolderTemplateName.value = ''; return; }
  const idUsuarioSesion = localStorage.getItem('idUsuario');
  const response = await axios.get(`/api/Plantillas/list-plantillas?idUsuarioSesion=${idUsuarioSesion}`);
  if (response.data.success) {
    const encontrada = response.data.data.find(p => Number(p.codigo) === Number(templateId));
    selectedFolderTemplateName.value = encontrada ? encontrada.plantilla : '';
  }
};


const enfocarTablaArchivos = () => {
  setTimeout(() => {
    // Buscar la primera fila de la tabla de archivos
    const primeraFila = document.querySelector(
      '.v-data-table tbody tr, .v-data-table .v-data-table__tr'
    )
    if (primeraFila) {
      primeraFila.setAttribute('tabindex', '0')
      primeraFila.focus()
      primeraFila.style.outline = '2px solid #1976d2'
      primeraFila.style.outlineOffset = '-2px'

      // Navegar filas con flechas ↑↓ dentro de la tabla
      primeraFila.addEventListener('keydown', navegarTabla, { once: false })
    }
  }, 100)
}


const navegarTabla = (event) => {
  const filas = Array.from(document.querySelectorAll(
    '.v-data-table tbody tr, .v-data-table .v-data-table__tr'
  ))
  const idx = filas.indexOf(event.currentTarget)

  // Limpiar outline de todas
  filas.forEach(f => {
    f.style.outline = ''
    f.style.outlineOffset = ''
  })

  if (event.key === 'ArrowDown') {
    event.preventDefault()
    const siguiente = filas[idx + 1]
    if (siguiente) {
      siguiente.setAttribute('tabindex', '0')
      siguiente.focus()
      siguiente.style.outline = '2px solid #1976d2'
      siguiente.style.outlineOffset = '-2px'
      siguiente.addEventListener('keydown', navegarTabla, { once: false })
    } else {
      // ✅ Última fila → ir a página siguiente
      const btnSiguientePagina = document.querySelector(
        '.v-data-table-footer button[aria-label="Next page"], ' +
        '.v-data-table-footer .v-btn:not([disabled])[aria-label*="next"], ' +
        '.v-pagination__next button:not([disabled]), ' +
        'button[aria-label="Go to next page"]:not([disabled])'
      )
      if (btnSiguientePagina && !btnSiguientePagina.disabled) {
        btnSiguientePagina.click()
        // Después de cambiar página, enfocar la primera fila
        setTimeout(() => {
          const primeraFila = document.querySelector(
            '.v-data-table tbody tr, .v-data-table .v-data-table__tr'
          )
          if (primeraFila) {
            primeraFila.setAttribute('tabindex', '0')
            primeraFila.focus()
            primeraFila.style.outline = '2px solid #1976d2'
            primeraFila.style.outlineOffset = '-2px'
            primeraFila.addEventListener('keydown', navegarTabla, { once: false })
          }
        }, 300)
      }
    }

  } else if (event.key === 'ArrowUp') {
    event.preventDefault()
    const anterior = filas[idx - 1]
    if (anterior) {
      anterior.setAttribute('tabindex', '0')
      anterior.focus()
      anterior.style.outline = '2px solid #1976d2'
      anterior.style.outlineOffset = '-2px'
      anterior.addEventListener('keydown', navegarTabla, { once: false })
    } else {
      // ✅ Primera fila → ir a página anterior
      const btnPaginaAnterior = document.querySelector(
        '.v-data-table-footer button[aria-label="Previous page"], ' +
        '.v-data-table-footer .v-btn:not([disabled])[aria-label*="prev"], ' +
        '.v-pagination__prev button:not([disabled]), ' +
        'button[aria-label="Go to previous page"]:not([disabled])'
      )
      if (btnPaginaAnterior && !btnPaginaAnterior.disabled) {
        btnPaginaAnterior.click()
        // Después de cambiar página, enfocar la última fila
        setTimeout(() => {
          const todasFilas = Array.from(document.querySelectorAll(
            '.v-data-table tbody tr, .v-data-table .v-data-table__tr'
          ))
          const ultimaFila = todasFilas[todasFilas.length - 1]
          if (ultimaFila) {
            ultimaFila.setAttribute('tabindex', '0')
            ultimaFila.focus()
            ultimaFila.style.outline = '2px solid #1976d2'
            ultimaFila.style.outlineOffset = '-2px'
            ultimaFila.addEventListener('keydown', navegarTabla, { once: false })
          }
        }, 300)
      }
    }

  } else if (event.key === 'ArrowLeft') {
    event.preventDefault()
    filas.forEach(f => { f.style.outline = ''; f.style.outlineOffset = '' })
    setTimeout(() => {
      const itemActivo = document.querySelector('.v-list-item--active, .v-list-item:focus')
      if (itemActivo) itemActivo.focus()
      else {
        const primerItem = document.querySelector('.v-list .v-list-item')
        if (primerItem) primerItem.focus()
      }
    }, 50)

  } else if (event.key === 'Enter') {
    event.preventDefault()
    event.currentTarget.dispatchEvent(new MouseEvent('dblclick', { bubbles: true }))

  } else if (event.key === 'Escape') {
    event.preventDefault()
    filas.forEach(f => { f.style.outline = ''; f.style.outlineOffset = '' })
  }
}



const aplicarZoomEnPunto = async (nuevoZoom, puntoX = null, puntoY = null) => {
  const container = pdfScrollContainer.value;
  const zAntes = zoomEfectivoArchivo.value;
  const zDespues = Math.min(
    MAX_ZOOM_ARCHIVO,
    Math.max(MIN_ZOOM_ARCHIVO, nuevoZoom)
  );

  const px = puntoX ?? (container ? container.clientWidth / 2 : 0);
  const py = puntoY ?? (container ? container.clientHeight / 2 : 0);
  const stAntes = container ? container.scrollTop : 0;
  const slAntes = container ? container.scrollLeft : 0;

  zoomArchivoLevel.value = zDespues;

  if (!container || zAntes === zDespues) return;

  // El layout ya cambió (los marcos son reactivos) → ajustar scroll con valores FINALES
  await nextTick();
  const k = zDespues / zAntes;
  container.scrollTop = Math.max(0, (stAntes + py) * k - py);
  container.scrollLeft = Math.max(0, (slAntes + px) * k - px);
};









</script>

<script>
import TreeNode from './treeNode.vue'; //llama al archivo TreeNode.vue para renderizar los nodo hijas, mediante el componente TreeNode, lo esta jalando desde el archivo TreeNode.vue

export default {
  components: {
    TreeNode //componente de TreeNode en el front end lo llama así: <tree-node></tree-node>
  }
};
</script>


<style scoped>
/* Estilos para tabla de versiones */
.tabla-versiones {
  border: 1px solid #e0e0e0;
}

.tabla-versiones :deep(th) {
  background-color: #f5f5f5 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #333 !important;
  border-bottom: 1px solid #e0e0e0 !important;
  border-right: 1px solid #e0e0e0 !important;
}

.tabla-versiones :deep(td) {
  font-size: 12px !important;
  padding: 8px 16px !important;
  border-right: 1px solid #e0e0e0 !important;
}

.tabla-versiones :deep(tr:nth-child(even)) {
  background-color: #f9f9f9 !important;
}

.tabla-versiones :deep(tr:hover) {
  background-color: #f0f0f0 !important;
}

/* Estilos para botones de paginación */
.pagination-btn {
  font-size: 11px !important;
  height: 26px !important;
  text-transform: none !important;
}
</style>


<style scoped>
/* Estilos para el modal de nueva versión */
.tabla-header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 600;
  font-size: 12px;
  color: #333;
}

.drop-zone {
  min-height: 180px;
  border: 2px dashed transparent;
  transition: all 0.3s;
  overflow-y: auto;
  max-height: 250px;
}

.drop-zone-active {
  border-color: #1976d2;
  background-color: #e3f2fd;
}

.archivo-row {
  border-bottom: 1px solid #e0e0e0;
  font-size: 12px;
}

.archivo-row:hover {
  background-color: #f5f5f5;
}

.archivo-row:last-child {
  border-bottom: none;
}
</style>



<style scoped>
/* Estilos para tabla de versiones */
.tabla-versiones {
  border: 1px solid #e0e0e0;
}

.tabla-versiones :deep(th) {
  background-color: #f5f5f5 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #333 !important;
  border-bottom: 1px solid #e0e0e0 !important;
  border-right: 1px solid #e0e0e0 !important;
}

.tabla-versiones :deep(td) {
  font-size: 12px !important;
  padding: 8px 16px !important;
  border-right: 1px solid #e0e0e0 !important;
}

.tabla-versiones :deep(tr:nth-child(even)) {
  background-color: #f9f9f9 !important;
}

/* Filas de versiones con hover */
.fila-version {
  cursor: pointer;
  transition: background-color 0.2s;
}

.fila-version:hover {
  background-color: #e3f2fd !important;
}

.fila-version-seleccionada {
  background-color: #bbdefb !important;
}

/* Estilos para botones de paginación */
.pagination-btn {
  font-size: 11px !important;
  height: 26px !important;
  text-transform: none !important;
}

/* Menú contextual de versiones */
.menu-contextual-version {
  min-width: 200px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;
}

.menu-item-version {
  font-size: 13px !important;
  min-height: 36px !important;
}

.menu-item-version:hover {
  background-color: #f5f5f5 !important;
}

</style>


<style>
  .dialog-indexacion .v-overlay__content {
  max-height: 97vh !important;
  height: 97vh !important;
  max-width: 1400px !important;
  width: 97vw !important;
  margin: 0 !important;
}

.dialog-indexacion .v-overlay__content .v-card {
  height: 100% !important;
  max-height: 100% !important;
  overflow: hidden !important;
}

.swal-sobre-modal {
  z-index: 3000 !important;
}



/* ===== STICKY NOTES ===== */
.sticky-note {
  position: absolute;
  z-index: 10;
  width: 200px;
  background: #fff9c4;
  border: 1px solid #f0e68c;
  border-radius: 2px;
  box-shadow: 2px 2px 8px rgba(0,0,0,0.3);
  font-family: 'Segoe UI', sans-serif;
  transform: translate(0, 0);
  pointer-events: auto;
}

.sticky-note-editing {
  width: 220px;
  z-index: 20;
  box-shadow: 3px 3px 12px rgba(0,0,0,0.4);
}

.sticky-note-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 6px;
  border-bottom: 1px solid #f0e68c;
  min-height: 24px;
}

.sticky-note-number {
  font-size: 10px;
  font-weight: 600;
  color: #b8860b;
}

.sticky-note-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

.sticky-note-btn {
  cursor: pointer;
  color: #999 !important;
  transition: color 0.2s;
}

.sticky-note-btn:hover {
  color: #333 !important;
}

.sticky-note-btn-delete:hover {
  color: #d32f2f !important;
}

.sticky-note-body {
  padding: 6px 8px;
  font-size: 12px;
  color: #333;
  word-wrap: break-word;
  max-height: 120px;
  overflow-y: auto;
  line-height: 1.4;
}

.sticky-note-textarea {
  width: 100%;
  border: none;
  background: transparent;
  padding: 6px 8px;
  font-size: 12px;
  color: #333;
  resize: none;
  outline: none;
  font-family: 'Segoe UI', sans-serif;
  line-height: 1.4;
}

.sticky-note-textarea::placeholder {
  color: #bbb;
}

.sticky-note-footer {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  padding: 4px 6px;
  border-top: 1px solid #f0e68c;
}

.sticky-btn {
  padding: 2px 10px;
  font-size: 11px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 500;
}

.sticky-btn-cancel {
  background: transparent;
  color: #999;
}

.sticky-btn-cancel:hover {
  color: #333;
}

.sticky-btn-save {
  background: #f9a825;
  color: white;
}

.sticky-btn-save:hover {
  background: #f57f17;
}



</style>


<style>

.swal-title-custom {
  color: #004d82 !important;
}

.swal-btn-eliminar {
  color: #ffffff !important;  /* texto blanco */
}

.swal-btn-cancelar {
  color: #ffffff !important;  /* texto blanco */
}

.swal-loader-custom {
  border-color: #ce501b transparent transparent transparent !important;
}


</style>


<style scoped>


/* ===== DIVISOR REDIMENSIONABLE ===== */
.split-divider {
  width: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: col-resize;
  background: #f0f0f0;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  transition: background 0.2s;
  position: relative;
}

.split-divider:hover {
  background: #d0e8f5;
}

.split-divider-handle {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.split-divider-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  border: 2px solid #004d82;
  box-shadow: 0 1px 4px rgba(0,0,0,0.25);
}

/* Línea vertical del divisor */
.split-divider::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 2px;
  background: #bdbdbd;
  transform: translateX(-50%);
  z-index: 0;
}

.split-divider-handle {
  z-index: 1;
}


.swal-sobre-modal {
  z-index: 99999 !important;
}

.swal-sobre-modal .swal2-textarea {
  z-index: 99999 !important;
  pointer-events: auto !important;
}



</style>

<style scoped>
.chip-destacado :deep(.v-chip__content) {
  font-weight: 700;
  color: #000000 !important;
  font-size: 0.95rem;
}
</style>

<style>
.textLayer {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  line-height: 1;
  text-align: initial;
  isolation: isolate; /* ✅ NUEVO: crea stacking context propio */
}

/* El contenedor scrollable no participa en la selección */
[ref="pdfScrollContainer"], .textLayer ~ * {
  user-select: none;
}

.textLayer, .textLayer span {
  user-select: text;
}

.textLayer span,
.textLayer br {
  color: transparent;      /* el texto es invisible, solo se ve la selección */
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
  letter-spacing: 0;   /* ✅ NUEVO */
  word-spacing: 0;     /* ✅ NUEVO */
}

.textLayer ::selection {
  background: rgba(0, 100, 255, 0.35);
}

.textLayer .endOfContent {
  display: block;
  position: absolute;
  inset: 100% 0 0; /* colapsado: empieza donde termina la página */
  z-index: -1;
  cursor: default;
  user-select: none;
}

.textLayer .endOfContent.active {
  top: 0; /* mientras arrastras: se expande y cubre toda la página */
}

.textLayer span {
  box-sizing: border-box;
}

</style>
